

(function () {
  var FUENTE = '"Helvetica Neue vevvia","Helvetica Neue",Helvetica,Arial,sans-serif';
  var ESCENAS = [
    { id: 'hoja', titulo: 'Todo empieza en la naturaleza.', sub: 'Resina de boswelia, mejillón de labio verde, membrana de huevo.' },
    { id: 'balanza', titulo: 'Y se pesa al miligramo.', sub: 'Seis activos, cada uno con su cantidad en la etiqueta.' },
    { id: 'cuchara', titulo: '930 mg en cada cucharada.', sub: 'Una cucharada rasa de 3 g, mezclada con su comida.' },
    { id: 'perro', titulo: 'Para cuidar sus articulaciones. Nada más.', sub: 'Sin colorantes, sin cereales, sin saborizantes.' }
  ];

  var DIBUJOS = {
    hoja: function (x) {
      x.lineCap = 'round'; x.lineWidth = .1;
      x.beginPath(); x.moveTo(-.25, 1.05); x.bezierCurveTo(-.2, .4, .05, -.3, .3, -1.0); x.stroke();
      function hoja(cx, cy, r, l) {
        x.save(); x.translate(cx, cy); x.rotate(r);
        x.beginPath(); x.moveTo(0, 0); x.bezierCurveTo(l * .35, -l * .32, l * .75, -l * .26, l, 0);
        x.bezierCurveTo(l * .75, l * .26, l * .35, l * .32, 0, 0); x.fill();
        x.globalCompositeOperation = 'destination-out'; x.lineWidth = .035;
        x.beginPath(); x.moveTo(l * .1, 0); x.lineTo(l * .85, 0); x.stroke();
        x.globalCompositeOperation = 'source-over'; x.restore();
      }
      hoja(-.19, .55, Math.PI + .5, .62); hoja(-.13, .3, -.45, .6);
      hoja(-.02, -.05, Math.PI + .35, .58); hoja(.07, -.32, -.6, .55);
      hoja(.18, -.62, Math.PI + .2, .46); hoja(.3, -1.0, -1.1, .34);
    },
    balanza: function (x) {
      x.lineCap = 'round'; x.lineJoin = 'round';
      x.beginPath(); x.moveTo(-.45, 1.0); x.lineTo(.45, 1.0); x.lineTo(.3, .86); x.lineTo(-.3, .86); x.closePath(); x.fill();
      x.lineWidth = .11; x.beginPath(); x.moveTo(0, .88); x.lineTo(0, -.72); x.stroke();
      x.beginPath(); x.arc(0, -.8, .1, 0, 7); x.fill();
      x.lineWidth = .09; x.beginPath(); x.moveTo(-.95, -.62); x.lineTo(.95, -.62); x.stroke();
      x.lineWidth = .035;
      [-1, 1].forEach(function (sg) {
        var px = .85 * sg;
        x.beginPath(); x.moveTo(px, -.6); x.lineTo(px - .28, .1); x.moveTo(px, -.6); x.lineTo(px + .28, .1); x.stroke();
        x.beginPath(); x.moveTo(px - .36, .1); x.quadraticCurveTo(px, .42, px + .36, .1); x.closePath(); x.fill();
      });

      x.beginPath(); x.moveTo(-1.12, .08); x.quadraticCurveTo(-.85, -.12, -.58, .08); x.closePath(); x.fill();
    },
    cuchara: function (x) {
      x.save(); x.rotate(-.35);
      x.beginPath(); x.ellipse(-.38, 0, .52, .36, 0, 0, 7); x.fill();
      x.beginPath(); x.moveTo(.1, -.07); x.lineTo(1.1, -.05); x.quadraticCurveTo(1.2, 0, 1.1, .05); x.lineTo(.1, .07); x.closePath(); x.fill();
      x.globalCompositeOperation = 'destination-out';
      x.beginPath(); x.ellipse(-.38, 0, .4, .25, 0, 0, 7); x.fill();
      x.globalCompositeOperation = 'source-over';
      x.beginPath(); x.moveTo(-.8, .02); x.bezierCurveTo(-.6, -.42, -.18, -.42, .02, .02); x.closePath(); x.fill();
      x.restore();

      [[-.2, -.75, .05], [-.42, -.95, .04], [.0, -1.05, .035], [-.3, -1.22, .03]].forEach(function (g) { x.beginPath(); x.arc(g[0], g[1], g[2], 0, 7); x.fill(); });
    }
  };

  function vevviaPolvo(fig) {
    var cv = fig.querySelector('canvas'), img = fig.querySelector('[data-polvo-forma]');
    if (!cv || !img) return;
    var ctx = cv.getContext('2d');
    var quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var W = 0, H = 0, DPR = Math.min(window.devicePixelRatio || 1, 2);
    var N = 0, ancho = false, P = [], formas = {}, visible = false, empezado = false, t0 = 0, corriendo = false;
    var raton = { x: -9999, y: -9999, on: false };
    var COLS = ['#5E2E20', '#6E3826', '#4A2318', '#AD563B', '#7A4A35'];

    var GUION = [[0, 'nube', 1.0, .010]], t = 2200;
    ESCENAS.forEach(function (e, i) { GUION.push([t, e.id, .12, .048, i]); t += i === ESCENAS.length - 1 ? 4600 : 3900; });
    GUION.push([t, 'nube', 1.0, .01]); t += 2200;
    var CICLO = t;

    function rnd(a, b) { return a + Math.random() * (b - a); }

    function muestrear(dibuja, borde) {
      var c = document.createElement('canvas'); c.width = W; c.height = H;
      var x = c.getContext('2d'); x.fillStyle = '#000'; x.strokeStyle = '#000';
      try { dibuja(x); } catch (e) {}
      var d; try { d = x.getImageData(0, 0, W, H).data; } catch (e) { d = new Uint8ClampedArray(W * H * 4); }
      var A = function (i, y) { return i < 0 || y < 0 || i >= W || y >= H ? 0 : d[(y * W + i) * 4 + 3]; };
      var ed = [], fi = [], paso = W > 700 ? 2 : 1, g = Math.max(2, Math.round(Math.min(W, H) / 160));
      for (var y = 0; y < H; y += paso) for (var i = 0; i < W; i += paso) {
        if (A(i, y) < 128) continue;
        if (borde && A(i - g, y) > 127 && A(i + g, y) > 127 && A(i, y - g) > 127 && A(i, y + g) > 127) fi.push(i, y);
        else ed.push(i, y);
      }
      var out = new Float32Array(N * 2), ne = ed.length / 2, nf = fi.length / 2;
      if (!ne && !nf) { for (var z = 0; z < N; z++) { out[z * 2] = W / 2; out[z * 2 + 1] = H / 2; } out.vacio = true; return out; }
      for (var k = 0; k < N; k++) {
        var src = (nf && Math.random() < .14) || !ne ? fi : ed, n = src.length / 2, j = (Math.random() * n) | 0;
        out[k * 2] = src[j * 2] + rnd(-.6, .6); out[k * 2 + 1] = src[j * 2 + 1] + rnd(-.6, .6);
      }
      return out;
    }

    function preparar() {
      var r = fig.getBoundingClientRect();
      W = Math.max(200, Math.round(r.width)); H = Math.max(200, Math.round(r.height));
      cv.width = W * DPR; cv.height = H * DPR; cv.style.width = W + 'px'; cv.style.height = H + 'px';
      ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
      N = Math.round(Math.min(4200, Math.max(1800, W * H / 60)));
      ancho = W / H > 1.6;

      var nube = new Float32Array(N * 2);
      for (var k = 0; k < N; k++) {
        var u = Math.random(), a = rnd(-1, 1) * Math.pow(Math.random(), .6);
        var cx = W * (.28 + .5 * u), cy = H * (.6 - .3 * u + .05 * Math.sin(u * 9));
        nube[k * 2] = cx + rnd(-8, 8); nube[k * 2 + 1] = cy + a * H * (.05 + .1 * Math.sin(Math.PI * u));
      }
      formas.nube = nube;

      var s = ancho ? H * .36 : Math.min(H * .25, W * .22), cxx = ancho ? W * .3 : W / 2, cyy = ancho ? H * .5 : H * .34;
      var ar = img.naturalWidth / img.naturalHeight || 1.65, hh = s * 1.5, ww = hh * ar;
      if (ww > (ancho ? W * .5 : W * .8)) { ww = ancho ? W * .5 : W * .8; hh = ww / ar; }
      formas.perro = muestrear(function (x) { x.drawImage(img, cxx - ww / 2, cyy - hh / 2, ww, hh); }, false);
      Object.keys(DIBUJOS).forEach(function (id) {
        formas[id] = muestrear(function (x) { x.translate(cxx, cyy); x.scale(s, s); DIBUJOS[id](x); }, true);
      });

      var viejo = P; P = [];
      for (var k2 = 0; k2 < N; k2++) {
        var o = viejo[k2];
        P.push({
          x: o ? o.x : formas.nube[k2 * 2] + rnd(-W * .3, W * .3), y: o ? o.y : formas.nube[k2 * 2 + 1] + rnd(-H * .3, H * .3),
          vx: 0, vy: 0, s: rnd(.8, 2), c: COLS[(Math.random() * COLS.length) | 0], a: rnd(.55, 1), ph: Math.random() * 6.283, lag: Math.random()
        });
      }
    }

    function estado(ms) {
      var m = ms % CICLO, e = GUION[0], fin = CICLO;
      for (var i = 0; i < GUION.length; i++) if (m >= GUION[i][0]) { e = GUION[i]; fin = i + 1 < GUION.length ? GUION[i + 1][0] : CICLO; }
      var forma = e[1];
      if (formas[forma] && formas[forma].vacio) forma = 'nube';
      return { forma: forma, libre: e[2], k: e[3], dentro: m - e[0], queda: fin - m, esc: e[4] };
    }

    function campo(x, y, t) {
      return [Math.sin(y * .011 + t * .0006) + Math.sin((x + y) * .006 - t * .0004),
              Math.cos(x * .012 - t * .0005) + Math.cos((x - y) * .007 + t * .0003)];
    }

    function lineas(txt, maxw) {
      var pal = txt.split(' '), out = [], l = '';
      pal.forEach(function (p) { var pr = l ? l + ' ' + p : p; if (ctx.measureText(pr).width > maxw && l) { out.push(l); l = p; } else l = pr; });
      if (l) out.push(l); return out;
    }

    function texto(st) {
      if (st.esc === undefined) return;
      var al = Math.min(1, Math.max(0, (st.dentro - 600) / 500)) * Math.min(1, Math.max(0, (st.queda - 150) / 450));
      if (al <= 0) return;
      var e = ESCENAS[st.esc], sube = (1 - Math.min(1, Math.max(0, (st.dentro - 600) / 700))) * 8;
      var bb = ancho ? Math.max(15, Math.min(24, H * .07)) : Math.max(14, Math.min(19, W * .045));
      var lx = ancho ? W * .56 : W / 2, maxw = ancho ? W - lx - 16 : W * .86;
      ctx.textAlign = ancho ? 'left' : 'center'; ctx.textBaseline = 'alphabetic';
      ctx.font = '400 ' + bb * 1.55 + 'px ' + FUENTE; var L1 = lineas(e.titulo, maxw);
      ctx.font = '400 ' + bb * .82 + 'px ' + FUENTE; var L2 = lineas(e.sub, maxw);
      var lh1 = bb * 1.7, lh2 = bb * 1.2, alto = L1.length * lh1 + bb * .5 + L2.length * lh2 + bb * 1.4;
      var y = (ancho ? H * .5 - alto / 2 : H * .66) + lh1 * .78 + sube;
      ctx.globalAlpha = al; ctx.fillStyle = '#5E2E20'; ctx.font = '400 ' + bb * 1.55 + 'px ' + FUENTE;
      L1.forEach(function (l, i) { ctx.fillText(l, lx, y + i * lh1); });
      y += (L1.length - 1) * lh1 + bb * 1.3;
      ctx.globalAlpha = al * .95; ctx.fillStyle = '#AD563B'; ctx.font = '400 ' + bb * .82 + 'px ' + FUENTE;
      L2.forEach(function (l, i) { ctx.fillText(l, lx, y + i * lh2); });
      y += (L2.length - 1) * lh2 + bb * 1.25;
      var r0 = Math.max(2.5, bb * .16), sp = r0 * 4.2, x0 = ancho ? lx + r0 : lx - sp * 1.5;
      for (var j = 0; j < ESCENAS.length; j++) {
        ctx.globalAlpha = al * (j === st.esc ? .95 : .25); ctx.fillStyle = j === st.esc ? '#AD563B' : '#5E2E20';
        ctx.beginPath(); ctx.arc(x0 + j * sp, y, r0, 0, 7); ctx.fill();
      }
      ctx.globalAlpha = 1;
    }

    function cuadro(now) {
      if (!visible) { corriendo = false; return; }
      corriendo = true;
      var tt = now - t0, st = estado(tt), tg = formas[st.forma];
      ctx.clearRect(0, 0, W, H);
      var resp = Math.sin(tt * .0018) * .6;
      for (var i = 0; i < N; i++) {
        var p = P[i];
        var listo = Math.min(1, Math.max(0, (st.dentro - p.lag * 800) / 550));
        var kk = st.k * (.25 + .75 * listo);
        var tx = tg[i * 2], ty = tg[i * 2 + 1] + (st.forma !== 'nube' ? resp : 0);
        var f = campo(p.x, p.y, tt), lib = st.libre * (st.forma === 'nube' ? 1 : (1 - listo * .85));
        p.vx += (tx - p.x) * kk + f[0] * .09 * lib;
        p.vy += (ty - p.y) * kk + f[1] * .09 * lib;
        if (raton.on) {
          var dx = p.x - raton.x, dy = p.y - raton.y, d2 = dx * dx + dy * dy;
          if (d2 < 6400) { var fz = (6400 - d2) / 6400 * 1.6, d = Math.sqrt(d2) || 1; p.vx += dx / d * fz; p.vy += dy / d * fz; }
        }
        p.vx *= .86; p.vy *= .86; p.x += p.vx; p.y += p.vy;
        ctx.globalAlpha = p.a * (.75 + .25 * Math.sin(tt * .003 + p.ph)); ctx.fillStyle = p.c;
        ctx.fillRect(p.x, p.y, p.s, p.s);
      }
      ctx.globalAlpha = 1;
      texto(st);
      requestAnimationFrame(cuadro);
    }

    function estatico() {
      ctx.clearRect(0, 0, W, H);
      var tg = formas.perro.vacio ? formas.cuchara : formas.perro;
      for (var i = 0; i < N; i++) { var p = P[i]; ctx.globalAlpha = p.a; ctx.fillStyle = p.c; ctx.fillRect(tg[i * 2], tg[i * 2 + 1], p.s, p.s); }
      ctx.globalAlpha = 1;
      texto({ esc: formas.perro.vacio ? 2 : 3, dentro: 5000, queda: 5000 });
    }

    function seguir() {
      if (quieto || corriendo || !visible) return;
      if (!empezado) { empezado = true; t0 = performance.now(); }
      requestAnimationFrame(cuadro);
    }

    function arrancar() {
      preparar();
      if (quieto) { estatico(); return; }
      if (!('IntersectionObserver' in window)) visible = true;
      seguir();
    }

    fig.addEventListener('pointermove', function (e) { var r = cv.getBoundingClientRect(); raton.x = e.clientX - r.left; raton.y = e.clientY - r.top; raton.on = true; });
    fig.addEventListener('pointerleave', function () { raton.on = false; });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { visible = es[0].isIntersecting && !document.hidden; seguir(); }, { threshold: .15 }).observe(fig);
    }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) visible = false;
      else { var r = fig.getBoundingClientRect(); visible = r.bottom > 0 && r.top < innerHeight; }
      seguir();
    });
    var rto, w0 = 0, h0 = 0, rehacer = function () {
      clearTimeout(rto); rto = setTimeout(function () {
        if (!img.naturalWidth || !P.length) return;
        var r = fig.getBoundingClientRect(); if (Math.abs(r.width - w0) < 2 && Math.abs(r.height - h0) < 2) return;
        w0 = r.width; h0 = r.height; preparar(); if (quieto) estatico();
      }, 200);
    };
    if ('ResizeObserver' in window) new ResizeObserver(rehacer).observe(fig); else window.addEventListener('resize', rehacer);

    if (img.complete && img.naturalWidth) arrancar(); else { img.addEventListener('load', arrancar); img.addEventListener('error', arrancar); }
  }
  window.vevviaPolvo = vevviaPolvo;
})();

(function () {
  'use strict';

  var ancho = window.matchMedia('(min-width: 1000px)');

  function colocarNombre() {
    var nombre = document.querySelector('.pdp-nombre');
    var desc   = document.querySelector('.pdp-datos .pdp-descriptor');
    if (!nombre || !desc) return;

    desc.parentNode.insertBefore(nombre, desc);
    desc.hidden = true;
  }

  var ticksCasa = null;

  function colocarTicks() {
    var nombre = document.querySelector('.pdp-nombre');
    var ticks  = document.querySelector('.pdp-datos .pdp-ticks');
    if (!nombre || !ticks) return;

    if (!ticksCasa) {
      ticksCasa = { padre: ticks.parentNode, siguiente: ticks.nextSibling };
    }

    var cabeza = document.querySelector('.pdp-cabeza');

    if (ancho.matches) {
      if (!cabeza) {
        cabeza = document.createElement('div');
        cabeza.className = 'pdp-cabeza';
        nombre.parentNode.insertBefore(cabeza, nombre);
        cabeza.appendChild(nombre);
      }
      cabeza.appendChild(ticks);
      return;
    }

    if (!cabeza) return;
    cabeza.parentNode.insertBefore(nombre, cabeza);
    ticksCasa.padre.insertBefore(ticks, ticksCasa.siguiente);
    cabeza.parentNode.removeChild(cabeza);
  }

  function colocarPestanas() {
    var ancla = document.getElementById('ss-tabs-icon-insert-block');
    var izq   = document.querySelector('.pdp-izq');
    var form  = document.querySelector('.pdp-compra__form');
    if (!ancla || !izq || !form) return;

    var bloque = document.querySelector('[class^="ss-tabs-icon-insert-block-"]');

    if (ancho.matches) {
      izq.appendChild(ancla);
      if (bloque) izq.appendChild(bloque);
    } else {

      var entrega = document.getElementById('ss-delivery');
      (entrega || form).insertAdjacentElement('afterend', ancla);
      if (bloque) ancla.insertAdjacentElement('afterend', bloque);
    }

    var rejilla = document.querySelector('.pdp-rejilla');
    var vacia = ancho.matches ? false : !izq.querySelector('*');
    izq.hidden = vacia;
    if (rejilla) rejilla.classList.toggle('pdp-rejilla--sin-izq', vacia);
  }

  var MESES = {
    ene:'enero', enero:'enero', feb:'febrero', febrero:'febrero',
    mar:'marzo', marzo:'marzo', abr:'abril', abril:'abril',
    may:'mayo', mayo:'mayo', jun:'junio', junio:'junio',
    jul:'julio', julio:'julio', ago:'agosto', agosto:'agosto',
    sep:'septiembre', sept:'septiembre', oct:'octubre', octubre:'octubre',
    nov:'noviembre', noviembre:'noviembre', dic:'diciembre', diciembre:'diciembre'
  };

  function fechasEnEspanol() {
    var nodos = document.querySelectorAll('[class^="delivery-date-"]');
    for (var i = 0; i < nodos.length; i++) {
      var t = nodos[i].textContent.replace(/\s+/g, ' ').trim();
      var m = t.match(/^(\d{1,2})\s+([A-Za-zÁÉÍÓÚáéíóú]+)\.?$/);
      if (!m) continue;
      var mes = MESES[m[2].toLowerCase()];
      if (!mes) continue;
      nodos[i].textContent = m[1] + ' de ' + mes;
    }
  }

  window.addEventListener('load', fechasEnEspanol);

  colocarPestanas();

  colocarNombre();

  colocarTicks();
  if (ancho.addEventListener) {
    ancho.addEventListener('change', colocarPestanas);
    ancho.addEventListener('change', colocarTicks);
  }
})();

(function () {
  'use strict';

  var I18N = window.VEVVIA_I18N;

  function dic() { return I18N.diccionario; }

  var MARCA = {
    si: '<svg class="comparativa__marca" viewBox="0 0 32 32" aria-hidden="true" focusable="false">' +
        '<circle cx="16" cy="16" r="14.5" fill="none" stroke="currentColor" stroke-width="1.6"/>' +
        '<path d="M9.5 16.6l4.4 4.4 9-9.4" fill="none" stroke="currentColor" stroke-width="2" ' +
        'stroke-linecap="round" stroke-linejoin="round"/></svg>',
    no: '<svg class="comparativa__marca" viewBox="0 0 32 32" aria-hidden="true" focusable="false">' +
        '<circle cx="16" cy="16" r="14.5" fill="none" stroke="currentColor" stroke-width="1.6"/>' +
        '<path d="M11 11l10 10M21 11L11 21" fill="none" stroke="currentColor" stroke-width="2" ' +
        'stroke-linecap="round"/></svg>'
  };

  function celda(estado) {
    var si = estado === 'si';
    return MARCA[si ? 'si' : 'no'] +
           '<span class="visualmente-oculto">' +
           I18N.t(si ? 'comparativa.si' : 'comparativa.no') + '</span>';
  }

  function pintarTablaFaq(ambito) {
    var cuerpo = ambito.querySelector('[data-faq-tabla]');
    if (!cuerpo) return;

    var total = Number(cuerpo.getAttribute('data-total')) || 5;

    for (var i = 1; i <= total; i++) {
      var fila = I18N.t('faq.t' + i);
      if (!fila || !fila.length) continue;

      var tr = document.createElement('tr');

      tr.innerHTML = '<th scope="row"></th><td></td>';
      tr.querySelector('th').textContent = fila[0];
      tr.querySelector('td').textContent = fila[1];
      cuerpo.appendChild(tr);
    }
  }

  var INTERVALO_ANUNCIOS = 4000;

  function iniciarAnuncios() {
    var anuncios = document.querySelectorAll('#anuncios .anuncio');
    if (anuncios.length < 2) return;

    var indice = 0;
    var reloj = null;

    function mostrar(nuevo) {
      anuncios[indice].hidden = true;

      indice = (nuevo + anuncios.length) % anuncios.length;
      anuncios[indice].hidden = false;
    }

    function arrancarReloj() {
      clearInterval(reloj);
      reloj = setInterval(function () { mostrar(indice + 1); }, INTERVALO_ANUNCIOS);
    }

    document.querySelectorAll('#anuncios [data-anuncio]').forEach(function (boton) {
      boton.addEventListener('click', function () {
        mostrar(indice + Number(boton.getAttribute('data-anuncio')));

        arrancarReloj();
      });
    });

    arrancarReloj();
  }

  function iniciarMarquesina() {
    var banda = document.querySelector('[data-marquesina]');
    if (!banda) return;

    var pista = banda.querySelector('.marquesina__pista');
    if (!pista) return;

    function cifras() {
      [].forEach.call(banda.querySelectorAll('.pill'), function (el) {
        if (el.querySelector('b') || !el.textContent) return;
        var t = el.textContent.replace(/[&<>]/g, function (c) {
          return { '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c];
        });
        el.innerHTML = t.replace(/\d[\d.,]*(?:\s?(?:mg|g)\b)?/g, '<b>$&</b>');
      });
    }
    cifras();
    if (window.VEVVIA_I18N && window.VEVVIA_I18N.listo) window.VEVVIA_I18N.listo.then(function () { cifras(); medir(); });

    var items = [].slice.call(banda.querySelectorAll('li'));
    var centros = [], ancho = 0;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      items.forEach(function (li) { li.style.setProperty('--foco', '1'); });
      return;
    }

    function medir() {
      ancho = banda.clientWidth;
      var o = banda.getBoundingClientRect().left - banda.scrollLeft;
      centros = items.map(function (li) {
        var r = li.getBoundingClientRect();
        return r.left - o + r.width / 2;
      });
    }

    function foco(p) {
      if (!items.length) return;
      var c = p + ancho / 2, rad = Math.max(220, ancho * 0.3);
      for (var i = 0; i < items.length; i++) {
        var t = 1 - Math.min(1, Math.abs(centros[i] - c) / rad);
        t = t * t * (3 - 2 * t);
        items[i].style.setProperty('--foco', (0.38 + 0.62 * t).toFixed(3));
      }
    }

    var impulso = 0, ultimoY = window.scrollY;
    window.addEventListener('scroll', function () {
      var d = Math.abs(window.scrollY - ultimoY);
      ultimoY = window.scrollY;
      impulso = Math.min(2.2, impulso + d * 0.012);
    }, { passive: true });

    medir();
    window.addEventListener('resize', medir);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(medir);

    function velocidad() {
      var v = parseFloat(getComputedStyle(banda).getPropertyValue('--velocidad'));
      return v > 0 ? v : 88;
    }

    var pos = 0;
    var anterior = null;
    var visible = true;

    function paso(ahora) {
      if (anterior !== null && visible) {
        var vuelta = pista.getBoundingClientRect().width;
        var dt = (ahora - anterior) / 1000;
        impulso *= Math.pow(0.25, dt);
        pos += dt * velocidad() * (1 + impulso);

        if (vuelta > 0 && pos >= vuelta) pos -= vuelta;
        banda.scrollLeft = pos;
        foco(pos);
      }
      anterior = ahora;
      requestAnimationFrame(paso);
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entradas) {
        visible = entradas[0].isIntersecting;

        if (visible) anterior = null;
      }).observe(banda);
    }

    foco(0);
    requestAnimationFrame(paso);
  }

  function iniciarTiraCompra() {
    var tira = document.querySelector('[data-ct]');
    if (!tira) return;
    var packs = [].slice.call(tira.querySelectorAll('[data-ct-pack]'));
    var id = tira.querySelector('[data-ct-id]');
    var ind = tira.querySelector('.ct__ind');
    var precio = tira.querySelector('[data-ct-precio]');
    var tachado = tira.querySelector('[data-ct-tachado]');
    var unidad = tira.querySelector('[data-ct-unidad]');
    var envio = tira.querySelector('[data-ct-envio]');
    var envioT = tira.querySelector('[data-ct-envio-t]');
    if (!packs.length || !id) return;
    var quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function t(k) { return (window.VEVVIA_I18N && window.VEVVIA_I18N.t) ? window.VEVVIA_I18N.t(k) : ''; }
    function eur(c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }
    var visto = null;

    function contar(destino) {
      var desde = visto;
      visto = destino;
      if (desde === null || desde === destino || quieto) { precio.textContent = eur(destino); return; }
      var t0 = performance.now();
      (function paso(ahora) {
        if (visto !== destino) return;
        var k = Math.min(1, (ahora - t0) / 500), e = 1 - Math.pow(1 - k, 3);
        precio.textContent = eur(Math.round(desde + (destino - desde) * e));
        if (k < 1) requestAnimationFrame(paso);
      })(t0);
    }

    function elegir(b) {
      var n = +b.getAttribute('data-ct-pack');
      var pr = +b.getAttribute('data-precio') || 0;
      var ta = +b.getAttribute('data-tachado') || 0;
      packs.forEach(function (x) { x.setAttribute('aria-checked', x === b ? 'true' : 'false'); });
      id.value = b.getAttribute('data-id');
      if (ind) ind.style.transform = 'translateX(' + (n - 1) * 100 + '%)';
      contar(pr);
      tachado.textContent = ta > pr ? eur(ta) : '';
      unidad.textContent = n > 1 ? (t('productos.1.unidad') || '{eur} / bote').replace('{eur}', eur(Math.round(pr / n))) : '';
      envio.classList.toggle('ct__envio--si', n > 1);
      envioT.textContent = t(n > 1 ? 'productos.1.envioSi' : 'productos.1.envioDesde');
    }

    packs.forEach(function (b) {
      b.addEventListener('click', function () { if (b.getAttribute('aria-checked') !== 'true') elegir(b); });

      b.addEventListener('keydown', function (e) {
        var i = packs.indexOf(b), j = e.key === 'ArrowRight' ? i + 1 : e.key === 'ArrowLeft' ? i - 1 : -9;
        if (j === -9) return;
        e.preventDefault();
        var o = packs[(j + packs.length) % packs.length];
        o.focus(); elegir(o);
      });
    });

    var pinta = function () { elegir(packs.filter(function (x) { return x.getAttribute('aria-checked') === 'true'; })[0] || packs[0]); };
    if (window.VEVVIA_I18N && window.VEVVIA_I18N.listo) window.VEVVIA_I18N.listo.then(pinta); else pinta();
  }

  function iniciarMenu() {
    var boton = document.querySelector('.nav__hamburguesa');
    var panel = document.getElementById('nav-panel');
    if (!boton || !panel) return;

    var cerrarBoton = panel.querySelector('.panel__cerrar');
    var fuera = panel.querySelector('.panel__fuera');

    function cerrar() {
      panel.classList.remove('abierto');
      document.body.classList.remove('sin-scroll');
      boton.setAttribute('aria-expanded', 'false');
      boton.setAttribute('aria-label', I18N.t('nav.abrirMenu'));
    }

    function abrir() {
      panel.classList.add('abierto');

      document.body.classList.add('sin-scroll');
      boton.setAttribute('aria-expanded', 'true');
      boton.setAttribute('aria-label', I18N.t('nav.cerrarMenu'));

      if (cerrarBoton) cerrarBoton.focus();
    }

    boton.addEventListener('click', function () {
      if (boton.getAttribute('aria-expanded') === 'true') {
        cerrar();
        boton.focus();
      } else {
        abrir();
      }
    });

    if (cerrarBoton) {
      cerrarBoton.addEventListener('click', function () {
        cerrar();
        boton.focus();
      });
    }

    if (fuera) fuera.addEventListener('click', cerrar);

    panel.addEventListener('click', function (evento) {
      if (evento.target.closest('a')) cerrar();
    });

    document.addEventListener('keydown', function (evento) {
      if (evento.key === 'Escape' && boton.getAttribute('aria-expanded') === 'true') {
        cerrar();
        boton.focus();
      }
    });
  }

  function iniciarLamas() {
    var caja = document.querySelector('[data-lamas]');
    if (!caja) return;

    var lamas = [].slice.call(caja.querySelectorAll('.lama'));
    if (!lamas.length) return;

    function abrir(cual, conFoco) {
      lamas.forEach(function (l, i) {
        var abierta = i === cual;
        l.classList.toggle('lama--abierta', abierta);
        l.setAttribute('aria-expanded', abierta ? 'true' : 'false');
      });

      if (caja.scrollWidth > caja.clientWidth) {
        var l2 = lamas[cual];
        var dur = parseFloat(getComputedStyle(l2).transitionDuration) || 0.55;
        setTimeout(function () {
          var rc = caja.getBoundingClientRect();
          var rl = l2.getBoundingClientRect();

          var pad = parseFloat(getComputedStyle(caja).paddingLeft) || 0;
          var destino = caja.scrollLeft + (rl.left - rc.left) - pad;
          caja.scrollTo({ left: Math.max(0, destino), behavior: 'smooth' });
        }, dur * 1000 + 40);
      }

      if (conFoco) lamas[cual].focus();
    }

    lamas.forEach(function (lama, i) {
      lama.addEventListener('click', function () { abrir(i); });

      lama.addEventListener('keydown', function (e) {
        var salto = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') salto = i + 1;
        if (e.key === 'ArrowLeft'  || e.key === 'ArrowUp')   salto = i - 1;
        if (e.key === 'Home') salto = 0;
        if (e.key === 'End')  salto = lamas.length - 1;
        if (salto === null) return;
        e.preventDefault();
        abrir((salto + lamas.length) % lamas.length, true);
      });
    });
  }

  function iniciarCarrito() {
    var cajon   = document.getElementById('carrito');
    var abridor = document.querySelector('[data-carrito-abrir]');
    if (!cajon || !abridor) return;

    var lista    = cajon.querySelector('.carro__lineas');
    var plantilla = cajon.querySelector('[data-carrito-linea]');
    var vacio    = cajon.querySelector('[data-carrito-vacio]');
    var total    = cajon.querySelector('[data-carrito-total]');
    var contador = document.querySelector('[data-carrito-contador]');
    var caja     = cajon.querySelector('.carro__caja');
    var ultimoFoco = null;

    var previas = {};

    var molde = plantilla ? plantilla.cloneNode(true) : null;
    if (plantilla) plantilla.remove();

    var PRECIO_UD = 3990;
    var TRAMOS = [
      { uds: 2, precio: 6990 },
      { uds: 3, precio: 8990 }
    ];

    function euros(cent) {
      return (cent / 100).toFixed(2).replace('.', ',') + ' €';
    }

    function ahorroDe(tr) {
      return Math.max(0, tr.uds * PRECIO_UD - tr.precio);
    }

    var tramos   = cajon.querySelector('[data-carrito-tramos]');
    var tramoTxt = cajon.querySelector('[data-carrito-tramos-texto]');
    var relleno  = cajon.querySelector('[data-carrito-relleno]');
    var barra    = relleno ? relleno.parentNode : null;
    var hitoMolde = null;
    if (barra) {
      var h = barra.querySelector('[data-carrito-hito]');
      if (h) { hitoMolde = h.cloneNode(true); h.remove(); }
    }

    var totalVisto = null;
    function contarTotal(destino) {
      var desde = totalVisto;
      totalVisto = destino;
      if (desde === null || desde === destino ||
          window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        total.textContent = dinero(destino);
        return;
      }
      var t0 = performance.now(), dura = 650;
      total.classList.add('carro__cifra--cuenta');
      (function paso(t) {
        var k = Math.min(1, (t - t0) / dura), e = 1 - Math.pow(1 - k, 3);
        if (totalVisto !== destino) return;
        total.textContent = dinero(Math.round(desde + (destino - desde) * e));
        if (k < 1) requestAnimationFrame(paso);
        else total.classList.remove('carro__cifra--cuenta');
      })(t0);
    }

    function dinero(centimos) {
      return (centimos / 100).toLocaleString('es-ES', {
        style: 'currency', currency: 'EUR'
      });
    }

    function sitio(uds) {
      var tope = TRAMOS[TRAMOS.length - 1].uds;
      if (tope <= 1) return 100;
      var p = (Math.min(uds, tope) - 1) / (tope - 1) * 100;
      return Math.max(0, Math.min(100, p));
    }

    function pintarTramos(uds, totalCent) {
      if (!tramos || !hitoMolde || !barra) return;

      tramos.hidden = uds < 1;
      if (uds < 1) return;

      if (relleno) relleno.style.width = sitio(uds) + '%';

      barra.querySelectorAll('.carro__hito').forEach(function (el) { el.remove(); });

      var siguiente = null;
      TRAMOS.forEach(function (tr) {
        var el = hitoMolde.cloneNode(true);
        el.hidden = false;
        el.style.left = sitio(tr.uds) + '%';
        el.classList.toggle('carro__hito--hecho', uds >= tr.uds);
        var et = el.querySelector('.carro__hito-etiqueta');
        if (et) et.textContent = '−' + euros(ahorroDe(tr));
        barra.appendChild(el);
        if (siguiente === null && uds < tr.uds) siguiente = tr;
      });

      if (!tramoTxt) return;
      if (siguiente) {
        var faltan = siguiente.uds - uds;
        var clave = faltan === 1 ? 'carrito.tramoFaltaUno' : 'carrito.tramoFaltaVarios';
        var texto = (window.VEVVIA_I18N && window.VEVVIA_I18N.t(clave)) || '';
        tramoTxt.textContent = String(texto)
          .replace('{n}', faltan)
          .replace('{eur}', euros(ahorroDe(siguiente)));
      } else {

        var ahorro = Math.max(0, uds * PRECIO_UD - (totalCent || 0));
        var tope = (window.VEVVIA_I18N && window.VEVVIA_I18N.t('carrito.tramoTope')) || '';
        tramoTxt.textContent = String(tope).replace('{eur}', euros(ahorro));
      }
    }

    var RESERVA_MS = 5 * 60 * 1000;
    var relojReserva = null;

    function guardado(clave) {
      try { return window.sessionStorage.getItem(clave); } catch (e) { return null; }
    }
    function guardar(clave, valor) {
      try { window.sessionStorage.setItem(clave, valor); } catch (e) {}
    }
    function olvidar(clave) {
      try { window.sessionStorage.removeItem(clave); } catch (e) {}
    }

    function mmss(ms) {
      var t = Math.max(0, Math.ceil(ms / 1000));
      var m = Math.floor(t / 60);
      var sg = t % 60;

      return (m < 10 ? "0" : "") + m + ":" + (sg < 10 ? "0" : "") + sg;
    }

    function pintarReserva(unidades) {
      var barra = cajon.querySelector("[data-carrito-reserva]");
      if (!barra) return;
      var hueco = barra.querySelector("[data-carrito-reserva-texto]");

      function apagar() {
        barra.hidden = true;
        if (relojReserva) { clearInterval(relojReserva); relojReserva = null; }
      }

      if (!unidades) {
        olvidar("vevvia:reserva");
        olvidar("vevvia:reserva:fin");
        apagar();
        return;
      }

      if (guardado("vevvia:reserva:fin") === "1") { apagar(); return; }

      var arranque = parseInt(guardado("vevvia:reserva"), 10);
      if (!arranque) { arranque = Date.now(); guardar("vevvia:reserva", String(arranque)); }

      function tic() {
        var queda = arranque + RESERVA_MS - Date.now();
        if (queda <= 0) { guardar("vevvia:reserva:fin", "1"); apagar(); return; }
        var plantilla = (window.VEVVIA_I18N && window.VEVVIA_I18N.t("carrito.reserva")) || "";
        if (hueco) hueco.innerHTML = plantilla.replace("{t}", "<b>" + mmss(queda) + "</b>");
        barra.hidden = false;
      }

      tic();
      if (!relojReserva && !barra.hidden) relojReserva = setInterval(tic, 1000);
    }

    var escaleras = {};
    var pedidas = {};
    var extrasDe = {};

    function botesDe(variante, puesto) {
      var m = /(\d+)/.exec(variante.title || '');
      return m ? Number(m[1]) : puesto + 1;
    }

    function escaleraDe(handle) {
      if (escaleras[handle] !== undefined) return Promise.resolve(escaleras[handle]);
      if (pedidas[handle]) return pedidas[handle];

      pedidas[handle] = fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (p) {

          var extra = null, vs = [];
          (p.variants || []).forEach(function (v) {
            if (/extra/i.test(v.title || '')) extra = { id: v.id, precio: v.price };
            else vs.push(v);
          });
          extrasDe[handle] = extra;
          var esc = vs.map(function (v, i) {
            var a = (v.selling_plan_allocations || [])[0];
            var planes = (v.selling_plan_allocations || []).map(function (x) { return String(x.selling_plan_id); });
            return { id: v.id, plan: a ? String(a.selling_plan_id) : '', planes: planes, botes: botesDe(v, i),
                     precio: v.price, precioSus: a ? a.price : v.price };
          });
          escaleras[handle] = esc.length > 1 ? esc : null;
          return escaleras[handle];
        })
        .catch(function () { escaleras[handle] = null; return null; });

      return pedidas[handle];
    }

    var marcoLimpio = null;

    function fetchLimpio() {
      try {
        if (!marcoLimpio || !marcoLimpio.contentWindow) {
          marcoLimpio = document.createElement('iframe');
          marcoLimpio.setAttribute('aria-hidden', 'true');
          marcoLimpio.tabIndex = -1;
          marcoLimpio.style.cssText = 'position:absolute;width:0;height:0;border:0;visibility:hidden';
          document.body.appendChild(marcoLimpio);
        }
        var f = marcoLimpio.contentWindow && marcoLimpio.contentWindow.fetch;
        if (f) return f.bind(marcoLimpio.contentWindow);
      } catch (e) {   }
      return window.fetch.bind(window);
    }

    function cambiarDePack(linea, destino) {
      var cuerpo = { id: destino.id, quantity: linea.quantity };

      if (linea.selling_plan_allocation && destino.plan) {
        var planNuevo = destino.plan;
        var spa = linea.selling_plan_allocation.selling_plan;
        var esc0 = escaleras[linea.handle] || [];
        for (var q = 0; q < esc0.length; q++) {
          if (esc0[q].id !== linea.variant_id) continue;
          var pos = (esc0[q].planes || []).indexOf(String(spa && spa.id));
          if (pos > -1 && destino.planes && destino.planes[pos]) planNuevo = destino.planes[pos];
        }
        cuerpo.selling_plan = Number(planNuevo);
      }
      if (linea.properties && Object.keys(linea.properties).length) cuerpo.properties = linea.properties;

      return fetchLimpio()(location.origin + '/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(cuerpo)
      })
        .then(function (r) { if (!r.ok) throw new Error('no entro'); return r.json(); })
        .then(function () { return cambiar(linea.key, 0); })
        .catch(function () { return leer(); });
    }

    function tx(k) { return (window.VEVVIA_I18N && window.VEVVIA_I18N.t(k)) || ''; }
    function fmt(k, v) {
      var s = String(tx(k));
      Object.keys(v || {}).forEach(function (n) { s = s.split('{' + n + '}').join(v[n]); });
      return s;
    }

    var VOCES = ['5', '6', '3', '7'];
    function pintarVoz(el, i) {
      if (!el) return;
      var k = 'resenas.' + VOCES[i % VOCES.length];
      var cita = tx(k + '.cita');
      if (!cita || cita === k + '.cita') { el.hidden = true; return; }
      el.innerHTML = '';
      var n = document.createElement('p'); n.className = 'carro__voz-nota'; n.textContent = tx('carrito.vozNota');
      var q = document.createElement('blockquote'); q.textContent = '«' + cita + '»';
      var c = document.createElement('figcaption'); c.textContent = tx(k + '.quien') + ', ' + tx(k + '.perro');
      el.appendChild(n); el.appendChild(q); el.appendChild(c);
      el.hidden = false;
    }

    cajon.querySelectorAll('[data-carrito-pack]').forEach(function (b, i) {
      b.addEventListener('click', function () {
        b.disabled = true;
        fetchLimpio()(location.origin + '/cart/add.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: Number(b.getAttribute('data-carrito-pack')), quantity: 1 })
        }).then(function () { return leer(); })
          .catch(function () { return leer(); })
          .then(function () { b.disabled = false; });
      });
    });

    function pintarSube(carro, botes) {
      var sube = cajon.querySelector('[data-carrito-sube]');
      var inc  = cajon.querySelector('[data-carrito-incluye]');
      var voz  = cajon.querySelector('[data-carrito-voz-lleno]');
      var ahorrando = cajon.querySelector('[data-carrito-ahorrando]');
      var vacioVoz = cajon.querySelector('[data-carrito-voz]');
      if (!sube) return;
      sube.hidden = true; sube.innerHTML = '';
      if (inc) { inc.hidden = true; inc.innerHTML = ''; }
      var modo0 = cajon.querySelector('[data-carrito-modo]');
      if (modo0) { modo0.hidden = true; modo0.innerHTML = ''; }

      if (!carro.items.length) {

        cajon.querySelectorAll('[data-carrito-pack-nota]').forEach(function (nota, i) {
          var ah = nota.getAttribute('data-carrito-pack-nota');
          nota.textContent = i === 0 ? tx('carrito.vacioPara1') : (ah ? fmt('carrito.vacioAhorras', { eur: ah }) : '');
        });
        if (voz) voz.hidden = true;
        if (ahorrando) ahorrando.hidden = true;
        pintarVoz(vacioVoz, 0);
        return;
      }
      pintarVoz(voz, botes);

      var ah = Math.max(0, botes * PRECIO_UD - carro.total_price);
      if (ahorrando) {
        ahorrando.hidden = ah < 50;
        ahorrando.textContent = fmt('carrito.ahorrando', { eur: euros(ah) });
      }

      if (carro.items.length !== 1) return;
      var it = carro.items[0];
      var esc = escaleras[it.handle];
      if (!esc) return;
      var q = it.quantity, soloUno = q === 1;
      var p = -1;
      for (var e = 0; e < esc.length; e++) if (esc[e].id === it.variant_id) { p = e; break; }
      if (p < 0) return;
      var sus = !!it.selling_plan_allocation;

      if (inc && soloUno) {
        for (var v = 1; v <= 5; v++) {
          var t = tx('pdp.formatos.f' + (p + 1) + '.v' + v);
          if (!t || t.indexOf('pdp.') === 0) continue;
          var li = document.createElement('li'); li.textContent = t; inc.appendChild(li);
        }
        inc.hidden = !inc.children.length;
      }

      var actual = esc[p];
      var precioDe = function (x) { return sus ? x.precioSus : x.precio; };

      var modo = cajon.querySelector('[data-carrito-modo]');
      if (modo) {
        modo.innerHTML = '';
        var ahorraSus = (actual.precio - actual.precioSus) * q;
        if (actual.plan) {
          modo.innerHTML = '<div><p class="carro__modo-t"></p><p class="carro__modo-x"></p></div>' +
            '<button type="button" class="carro__sw" role="switch"></button>';
          modo.querySelector('.carro__modo-t').textContent = sus ? tx('carrito.susActiva')
            : ahorraSus > 0 ? fmt('carrito.susOferta', { pr: euros(actual.precioSus * q) })
            : tx('carrito.susOfertaIgual');
          modo.querySelector('.carro__modo-x').textContent = sus ? tx('carrito.susActivaTexto')
            : ahorraSus > 0 ? fmt('carrito.susOfertaTexto', { eur: euros(ahorraSus) })
            : fmt('carrito.susOfertaIgualTexto', { pr: euros(actual.precioSus * q) });
          var sw = modo.querySelector('button');
          sw.setAttribute('aria-checked', sus ? 'true' : 'false');
          sw.setAttribute('aria-label', tx(sus ? 'carrito.susAQuitar' : 'carrito.susAPasar'));
          sw.addEventListener('click', function () {
            sw.disabled = true;
            sw.setAttribute('aria-checked', sus ? 'false' : 'true');
            cambiarModo(it, !sus, actual.plan);
          });

          var planes = actual.planes || [];
          var spa = it.selling_plan_allocation && it.selling_plan_allocation.selling_plan;
          var fAct = spa ? planes.indexOf(String(spa.id)) : -1;
          if (sus && planes.length > 1 && fAct > -1) {
            var fq = document.createElement('div');
            fq.className = 'carro__freq';
            fq.innerHTML = '<span class="cp__freqL"></span><span class="cp__freqOps" role="radiogroup" data-f="' + fAct + '"></span>';
            fq.firstChild.textContent = tx('pdp.cp.freqTit');
            var ops = fq.lastChild;
            ops.setAttribute('aria-label', tx('pdp.cp.freqTit'));
            planes.slice(0, 3).forEach(function (idP, i) {
              var b = document.createElement('button');
              b.type = 'button';
              b.className = 'cp__freqB';
              b.setAttribute('role', 'radio');
              b.setAttribute('aria-checked', i === fAct ? 'true' : 'false');
              b.textContent = tx('pdp.cp.freq' + (i + 1));
              b.addEventListener('click', function () {
                if (i === fAct || ops.getAttribute('aria-busy')) return;
                ops.setAttribute('aria-busy', 'true');
                ops.setAttribute('data-f', i);
                ops.querySelectorAll('.cp__freqB').forEach(function (x, j) { x.setAttribute('aria-checked', j === i ? 'true' : 'false'); });
                cambiarModo(it, true, idP);
              });
              ops.appendChild(b);
            });
            modo.appendChild(fq);
          }
          modo.hidden = false;
        }
      }

      if (p < esc.length - 1) {
        if (!soloUno) return;
        var sig = esc[p + 1];
        if (sus && !sig.plan) return;
        var pa = precioDe(actual), pb = precioDe(sig), extra = pb - pa;
        if (extra <= 0) return;
        var fotoSig = cajon.querySelector('[data-carrito-sube-img="' + sig.botes + '"]');
        var img = fotoSig ? fotoSig.getAttribute('src') : '';
        var gratisAhora = (p === 0);
        sube.innerHTML =
          (img ? '<img src="' + img + '" alt="" width="640" height="420">' : '') +
          '<div><p class="carro__sube-k"></p><p class="carro__sube-t"></p><p class="carro__sube-x"></p></div>' +
          '<button type="button" class="carro__sube-b"><span></span><span></span></button>';
        sube.querySelector('.carro__sube-k').textContent = tx(sig.botes >= 3 ? 'carrito.subeKicker3' : 'carrito.subeKicker2');
        sube.querySelector('.carro__sube-t').textContent = fmt(sus ? 'carrito.subeTituloSus' : 'carrito.subeTituloUna', { n: sig.botes });
        sube.querySelector('.carro__sube-x').textContent = fmt(gratisAhora ? 'carrito.subeTextoEnvio' : 'carrito.subeTexto', {
          pb: euros(Math.round(pb / sig.botes)), pa: euros(Math.round(pa / actual.botes)), extra: euros(extra)
        });
        var bt = sube.querySelector('button');
        bt.firstChild.textContent = fmt('carrito.subeBoton', { n: sig.botes });
        bt.lastChild.textContent = '+ ' + euros(extra);
        bt.addEventListener('click', function () { bt.disabled = true; cambiarDePack(it, sig); });
        sube.hidden = false;
      } else if (sus) {
        sube.innerHTML = '<span class="carro__sube-ok" aria-hidden="true">✓</span><div><p class="carro__sube-t"></p><p class="carro__sube-x"></p></div>';
        sube.classList.add('carro__sube--ok');
        sube.querySelector('.carro__sube-t').textContent = fmt('carrito.topeSus', { pb: euros(Math.round(precioDe(actual) / actual.botes)) });
        sube.querySelector('.carro__sube-x').textContent = tx('carrito.topeSusTexto');
        sube.hidden = false;
        return;
      }
      sube.classList.remove('carro__sube--ok');
    }

    function cambiarModo(linea, aSus, plan) {
      var cuerpo = { id: linea.variant_id, quantity: linea.quantity };
      if (aSus) {
        if (!plan) return leer();
        cuerpo.selling_plan = Number(plan);
      }
      if (linea.properties && Object.keys(linea.properties).length) cuerpo.properties = linea.properties;

      return fetchLimpio()(location.origin + '/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(cuerpo)
      })
        .then(function (r) { if (!r.ok) throw new Error('no entro'); return r.json(); })
        .then(function () { return cambiar(linea.key, 0); })
        .catch(function () { return leer(); });
    }

    function alta(id, cantidad) {
      return fetchLimpio()(location.origin + '/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: id, quantity: cantidad })
      }).then(function (r) { if (!r.ok) throw new Error('no entro'); return r.json(); });
    }
    function baja(clave) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: clave, quantity: 0 })
      }).then(function (r) { return r.json(); });
    }

    function meterBoteExtra(handle, carro) {
      var ex = extrasDe[handle];
      if (!ex) return leer();
      for (var i = 0; i < carro.items.length; i++) {
        if (carro.items[i].variant_id === ex.id) return cambiar(carro.items[i].key, carro.items[i].quantity + 1);
      }
      return alta(ex.id, 1).then(function () { return leer(); }).catch(function () { return leer(); });
    }

    function ajustarExtras(carro) {
      var tareas = [];
      var porHandle = {};
      carro.items.forEach(function (it) { (porHandle[it.handle] = porHandle[it.handle] || []).push(it); });
      Object.keys(porHandle).forEach(function (h) {
        var esc = escaleras[h], ex = extrasDe[h];
        if (!esc || !ex) return;
        var items = porHandle[h];
        var tres = items.some(function (x) { return !x.selling_plan_allocation && x.variant_id === esc[esc.length - 1].id; });
        var sobran = items.filter(function (x) {
          return !x.selling_plan_allocation && x.variant_id === (tres ? esc[0].id : ex.id);
        });
        if (!sobran.length) return;
        var n = sobran.reduce(function (a, x) { return a + x.quantity; }, 0);
        tareas.push({ id: tres ? ex.id : esc[0].id, n: n, claves: sobran.map(function (x) { return x.key; }) });
      });
      if (!tareas.length) return Promise.resolve(carro);
      var cadena = Promise.resolve();
      tareas.forEach(function (t) {
        cadena = cadena.then(function () { return alta(t.id, t.n); }).then(function () {
          var c2 = Promise.resolve();
          t.claves.forEach(function (k) { c2 = c2.then(function () { return baja(k); }); });
          return c2;
        });
      });

      return cadena
        .catch(function () {})
        .then(function () { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }); })
        .then(function (r) { return r.json(); });
    }

    function pintar(carro) {
      if (!molde || !lista) return;

      lista.querySelectorAll('.linea').forEach(function (el) { el.remove(); });

      var botes = 0;

      var packTres = {}, lineaExtra = {};
      carro.items.forEach(function (x) {
        var e0 = escaleras[x.handle], x0 = extrasDe[x.handle];
        if (x.selling_plan_allocation) return;
        if (e0 && x.variant_id === e0[e0.length - 1].id) packTres[x.handle] = x;
        if (x0 && x.variant_id === x0.id) lineaExtra[x.handle] = x;
      });
      Object.keys(lineaExtra).forEach(function (h) { if (!packTres[h]) delete lineaExtra[h]; });

      carro.items.forEach(function (it) {
        if (lineaExtra[it.handle] === it) { botes += it.quantity; return; }
        var exL = packTres[it.handle] === it ? lineaExtra[it.handle] : null;
        var li = molde.cloneNode(true);
        li.hidden = false;
        li.setAttribute('data-clave', it.key);

        var img = li.querySelector('img');
        if (img && it.image) {

          img.src = it.image.replace(/(\.[a-z]+)(\?|$)/i, '_320x$1$2');
          img.removeAttribute('srcset');
          img.alt = it.product_title;
        }
        var fuente = li.querySelector('source');
        if (fuente) fuente.remove();

        var nombre = li.querySelector('.linea__nombre');
        if (nombre) { nombre.removeAttribute('data-i18n'); nombre.textContent = it.product_title; }

        var formato = li.querySelector('.linea__formato');
        if (it.selling_plan_allocation) {
          var etq = document.createElement('span');
          etq.className = 'linea__sus';
          var nPlan = (it.selling_plan_allocation.selling_plan && it.selling_plan_allocation.selling_plan.name) || '';
          etq.textContent = tx('carrito.etiquetaSus').replace('{freq}', (nPlan || tx('pdp.cp.freq1')).toLowerCase());
          var datos = li.querySelector('.linea__datos');
          var precioP = li.querySelector('.linea__precio');
          if (datos && precioP) datos.insertBefore(etq, precioP);
        }
        if (formato && it.variant_title && it.variant_title.indexOf('Default') < 0) {
          formato.removeAttribute('data-i18n');
          formato.textContent = it.variant_title;
        }

        var esc = escaleras[it.handle] || null;
        var puesto = -1;
        if (esc) {
          for (var e = 0; e < esc.length; e++) {
            if (esc[e].id === it.variant_id) { puesto = e; break; }
          }
        }
        var porPack = (puesto >= 0) ? esc[puesto].botes : 1;

        var recortes = cajon.querySelectorAll('[data-carrito-pack] img');
        var recorte = recortes[Math.min(porPack, recortes.length) - 1];
        if (img && recorte && recorte.getAttribute('src')) {
          img.src = recorte.getAttribute('src');
          img.removeAttribute('srcset');
        }
        botes += it.quantity * porPack;

        if (formato && it.quantity > 1 && porPack > 1) {
          formato.removeAttribute('data-i18n');
          formato.textContent = fmt('carrito.formatoPacks', { n: it.quantity * porPack, q: it.quantity, p: porPack });
        }
        var hayArriba = puesto >= 0 && puesto < esc.length - 1;
        var hayAbajo  = puesto > 0;

        var uds = li.querySelector('[data-carrito-unidades]');
        if (uds) uds.textContent = String(it.quantity * porPack);

        var unica = !it.selling_plan_allocation;
        var esTres = puesto >= 0 && puesto === esc.length - 1;
        var exH = extrasDe[it.handle];
        var esExtra = !!(exH && it.variant_id === exH.id);
        if (esExtra) {
          var etx = document.createElement('span');
          etx.className = 'linea__sus linea__extra';
          etx.textContent = fmt('carrito.boteExtra', { pb: euros(exH.precio) });
          var datosX = li.querySelector('.linea__datos');
          var precioX = li.querySelector('.linea__precio');
          if (datosX && precioX) datosX.insertBefore(etx, precioX);
        }

        var menos = li.querySelector('[data-carrito-menos]');
        if (menos) {
          menos.disabled = it.quantity <= 1 && (!hayAbajo || esExtra);
          menos.addEventListener('click', function () {
            if (it.quantity > 1) return cambiar(it.key, it.quantity - 1);
            if (hayAbajo && !esExtra) return cambiarDePack(it, esc[puesto - 1]);
          });
        }
        var mas = li.querySelector('[data-carrito-mas]');
        if (mas) {
          mas.addEventListener('click', function () {
            if (esExtra) return cambiar(it.key, it.quantity + 1);
            if (hayArriba) return cambiarDePack(it, esc[puesto + 1]);
            if (unica && esTres && extrasDe[it.handle]) return meterBoteExtra(it.handle, carro);
            cambiar(it.key, it.quantity + 1);
          });
        }
        var imp = li.querySelector('[data-carrito-importe]');
        if (imp) imp.textContent = dinero(it.final_line_price);

        var quitar = li.querySelector('[data-carrito-quitar]');
        if (quitar) quitar.addEventListener('click', function () { cambiar(it.key, 0); });

        if (exL) {

          var nB = it.quantity * porPack + exL.quantity;
          if (uds) uds.textContent = String(nB);
          if (formato) { formato.removeAttribute('data-i18n'); formato.textContent = fmt('carrito.botesJuntos', { n: nB }); }
          var pill = document.createElement('span');
          pill.className = 'linea__sus linea__extra';
          pill.textContent = fmt('carrito.boteExtra', { pb: euros(extrasDe[it.handle].precio) });
          var datosJ = li.querySelector('.linea__datos'), precioJ = li.querySelector('.linea__precio');
          if (datosJ && precioJ) datosJ.insertBefore(pill, precioJ);
          if (imp) imp.textContent = dinero(it.final_line_price + exL.final_line_price);
          var nuevo = function (b) { if (!b) return null; var c = b.cloneNode(true); b.parentNode.replaceChild(c, b); c.disabled = false; return c; };
          var m2 = nuevo(menos), p2 = nuevo(mas), q2 = nuevo(quitar);
          if (m2) m2.addEventListener('click', function () { cambiar(exL.key, exL.quantity - 1); });
          if (p2) p2.addEventListener('click', function () { cambiar(exL.key, exL.quantity + 1); });
          if (q2) q2.addEventListener('click', function () { baja(exL.key).then(function () { cambiar(it.key, 0); }); });
        }

        lista.appendChild(li);
      });

      pintarTramos(botes, carro.total_price);
      pintarSube(carro, botes);

      previas = {};
      carro.items.forEach(function (it) { previas[it.key] = it.quantity; });

      pintarReserva(carro.item_count);
      pintarEntrega(carro.item_count);

      if (vacio)    vacio.hidden = carro.item_count > 0;
      if (total)    contarTotal(carro.total_price);
      if (contador) {
        contador.hidden = carro.item_count === 0;
        contador.textContent = String(botes);
      }
    }

    function colocarEntrega() {
      var caja = cajon.querySelector('[data-carrito-entrega-caja]');
      if (!caja) return;
      var movil = window.matchMedia('(max-width: 699px)').matches;
      var cuerpo = cajon.querySelector('.carro__cuerpo');
      var pie = cajon.querySelector('.carro__pie');
      var total2 = cajon.querySelector('.carro__total');

      var sueltos = [caja, cajon.querySelector('.carro__confia'), cajon.querySelector('.carro__pie .pagos, .carro__cuerpo > .pagos')];
      if (movil && cuerpo) {

        [caja, sueltos[1], sueltos[2]].forEach(function (e) { if (e) cuerpo.appendChild(e); });
      } else if (pie && total2) {
        if (caja.nextElementSibling !== total2) total2.insertAdjacentElement('beforebegin', caja);
        [sueltos[1], sueltos[2]].forEach(function (e) { if (e && e.parentNode !== pie) pie.appendChild(e); });
      }
      caja.classList.toggle('cent--cuerpo', movil);
    }
    colocarEntrega();
    window.addEventListener('resize', colocarEntrega);

    function pintarEntrega(n) {
      var caja = cajon.querySelector('[data-carrito-entrega-caja]');
      if (!caja) return;

      colocarEntrega();
      caja.hidden = !n;
      if (!n) return;
      var ahora = new Date();
      var p = {};
      try {
        new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Madrid', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hour12: false })
          .formatToParts(ahora).forEach(function (x) { p[x.type] = x.value; });
      } catch (e) {
        p = { year: ahora.getFullYear(), month: ahora.getMonth() + 1, day: ahora.getDate(), hour: ahora.getHours() };
      }
      var hoy = new Date(Number(p.year), Number(p.month) - 1, Number(p.day), 12);
      function mas(d, n2) { var r = new Date(d); r.setDate(r.getDate() + n2); return r; }
      function laborable(d) { var w = d.getDay(); return w === 6 ? mas(d, 2) : (w === 0 ? mas(d, 1) : d); }
      var tarde = Number(p.hour) >= 16 ? 1 : 0;
      var camino = laborable(mas(hoy, 1 + tarde));
      var llega = laborable(mas(camino, 3));
      var fmt = function (d) { return d.toLocaleDateString('es-ES', { day: 'numeric', month: 'long' }); };
      var fechas = [fmt(hoy), fmt(camino), fmt(llega)];
      caja.querySelectorAll('[data-carrito-entrega]').forEach(function (s2) {
        s2.textContent = fechas[Number(s2.getAttribute('data-carrito-entrega'))];
      });
    }

    function leer() {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })

        .then(function (carro) {
          var pendientes = [];
          carro.items.forEach(function (it) {
            if (it.handle && escaleras[it.handle] === undefined) pendientes.push(escaleraDe(it.handle));
          });
          return pendientes.length ? Promise.all(pendientes).then(function () { return carro; }) : carro;
        })
        .then(ajustarExtras)
        .then(pintar)
        .catch(function () {   });
    }

    function cambiar(clave, cantidad) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: clave, quantity: cantidad })
      }).then(function (r) { return r.json(); }).then(ajustarExtras).then(pintar).catch(function () {});
    }

    function abrir() {
      ultimoFoco = document.activeElement;
      cajon.classList.add('abierto');
      document.body.classList.add('sin-scroll');

      document.body.classList.add('carro-abierto');
      abridor.setAttribute('aria-expanded', 'true');

      if (caja) caja.focus({ preventScroll: true });
    }

    function cerrar() {
      cajon.classList.remove('abierto');
      document.body.classList.remove('sin-scroll');
      document.body.classList.remove('carro-abierto');
      abridor.setAttribute('aria-expanded', 'false');
      if (ultimoFoco && document.contains(ultimoFoco)) ultimoFoco.focus();
      ultimoFoco = null;
    }

    abridor.addEventListener('click', function () { leer(); abrir(); });

    cajon.querySelectorAll('[data-carrito-cerrar]').forEach(function (b) {
      b.addEventListener('click', cerrar);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && cajon.classList.contains('abierto')) cerrar();
    });

    function varianteDeUnBote() {
      var p = document.querySelector('[data-cp] .cp__pack');
      var r = p && p.querySelector('input[name="formato"]');
      return (r && Number(r.value)) || 0;
    }

    var metiendoBote = false;

    function meterUnBote() {
      if (metiendoBote) return;
      var id = varianteDeUnBote();
      if (!id) return;
      metiendoBote = true;

      fetchLimpio()(location.origin + '/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: id, quantity: 1 })
      })
        .then(function (r) { if (!r.ok) throw new Error('no entro'); return r.json(); })
        .then(function () { return leer(); })
        .then(abrir)
        .catch(function () {   })
        .then(function () { metiendoBote = false; });
    }

    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (!t.closest('.sticky-atc-wrapper')) return;

      var boton = t.closest('button, a');
      if (!boton || boton.getAttribute('name') !== 'add') return;

      if (!varianteDeUnBote()) return;

      e.preventDefault();
      e.stopPropagation();
      meterUnBote();
    }, true);

    document.querySelectorAll('.producto__compra, .pdp-compra__form').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return;
        e.preventDefault();

        var boton = form.querySelector('button[type="submit"]') || form.querySelector('button');
        if (boton) boton.disabled = true;

        var enviar = form.classList.contains('ct__accion') ? fetchLimpio() : fetch;
        enviar(location.origin + '/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        })
          .then(function (r) {
            if (!r.ok) throw new Error('no se pudo añadir');
            return r.json();
          })
          .then(leer)
          .then(abrir)
          .catch(function () { form.submit(); })
          .then(function () { if (boton) boton.disabled = false; });
      });
    });

    leer();
  }

  function iniciarProgreso() {
    var pasos = document.querySelectorAll('[data-progreso-paso]');
    if (!pasos.length) return;

    var estrecho = window.matchMedia('(max-width: 768px)');

    function aplicar() {
      pasos.forEach(function (paso) { paso.open = !estrecho.matches; });
    }

    aplicar();

    if (estrecho.addEventListener) estrecho.addEventListener('change', aplicar);
    else estrecho.addListener(aplicar);
  }

  function iniciarResenas() {
    var carrusel = document.querySelector('[data-resenas]');
    if (!carrusel) return;

    var pista = carrusel.querySelector('[data-resenas-pista]');
    var ventana = carrusel.querySelector('.resenas__ventana');
    if (!pista || !ventana) return;

    var reales = Array.prototype.slice.call(pista.querySelectorAll('.resenas__diapo'));
    if (!reales.length) return;

    var COPIAS = Math.min(6, reales.length);
    var bucle = reales.length > COPIAS;

    if (bucle) {

      for (var k = 0; k < COPIAS; k++) {
        var copiaFinal = reales[k].cloneNode(true);
        copiaFinal.setAttribute('aria-hidden', 'true');
        pista.appendChild(copiaFinal);

        var copiaInicio = reales[reales.length - 1 - k].cloneNode(true);
        copiaInicio.setAttribute('aria-hidden', 'true');
        pista.insertBefore(copiaInicio, pista.firstChild);
      }
    }

    function paso() {
      var d = pista.querySelector('.resenas__diapo');
      return d ? d.getBoundingClientRect().width : 0;
    }

    function saltar(a) {
      var antes = ventana.style.scrollSnapType;
      ventana.style.scrollSnapType = 'none';
      ventana.scrollLeft = a;

      void ventana.scrollLeft;
      ventana.style.scrollSnapType = antes || '';
    }

    function alPrincipio() { if (bucle) saltar(COPIAS * paso()); }

    function recolocar() {
      if (!bucle) return;
      var p = paso();
      if (!p) return;
      var inicio = COPIAS * p;
      var largo  = reales.length * p;
      var x = ventana.scrollLeft;

      if (x >= inicio + largo)     saltar(x - largo);
      else if (x < inicio - p / 2) saltar(x + largo);
    }

    if ('onscrollend' in window) {
      ventana.addEventListener('scrollend', recolocar);
    } else {
      var espera = null;
      ventana.addEventListener('scroll', function () {
        if (espera) clearTimeout(espera);
        espera = setTimeout(recolocar, 140);
      }, { passive: true });
    }

    var ancha = window.matchMedia('(min-width: 900px)');
    if (ancha.addEventListener) ancha.addEventListener('change', alPrincipio);
    else ancha.addListener(alPrincipio);

    window.addEventListener('resize', alPrincipio);

    alPrincipio();
  }

  function iniciarVideos() {
    var pista = document.querySelector('[data-videos-pista]');
    if (!pista) return;

    var tarjetas = pista.querySelectorAll('.videos__tarjeta');
    if (!tarjetas.length) return;

    tarjetas.forEach(function (tarjeta) {
      var video = tarjeta.querySelector('video');
      var boton = tarjeta.querySelector('[data-videos-play]');
      if (!video || !boton) return;

      function alternar() {
        if (video.paused) {

          tarjetas.forEach(function (otra) {
            var v = otra.querySelector('video');
            if (v && v !== video && !v.paused) v.pause();
          });
          video.play();
        } else {
          video.pause();
        }
      }

      boton.addEventListener('click', alternar);

      video.addEventListener('click', alternar);

      video.addEventListener('play', function () {
        tarjeta.classList.add('sonando');
        boton.setAttribute('aria-label', I18N.t('videos.pausar'));
      });

      video.addEventListener('pause', function () {
        tarjeta.classList.remove('sonando');
        boton.setAttribute('aria-label', I18N.t('videos.reproducir'));
      });
    });

    document.querySelectorAll('[data-videos-ir]').forEach(function (boton) {
      boton.addEventListener('click', function () {
        var primera = tarjetas[0];
        var paso = primera.getBoundingClientRect().width + 20;
        pista.scrollBy({
          left: paso * Number(boton.getAttribute('data-videos-ir')),
          behavior: 'smooth'
        });
      });
    });
  }

  function iniciarCalidad() {
    var seccion = document.getElementById('calidad');
    if (!seccion) return;

    var cabeceras = seccion.querySelectorAll('.calidad__cabecera');
    if (!cabeceras.length) return;

    cabeceras.forEach(function (cabecera) {
      cabecera.addEventListener('click', function () {
        var abierta = cabecera.getAttribute('aria-expanded') === 'true';

        cabeceras.forEach(function (otra) {
          otra.setAttribute('aria-expanded', 'false');
        });

        cabecera.setAttribute('aria-expanded', abierta ? 'false' : 'true');
      });
    });

    var video = seccion.querySelector('[data-calidad-video]');
    var boton = seccion.querySelector('[data-calidad-pausa]');

    if (video && boton) {
      boton.addEventListener('click', function () {
        if (video.paused) video.play(); else video.pause();
      });

      function pintar() {
        var parado = video.paused;
        boton.setAttribute('aria-pressed', parado ? 'true' : 'false');
        boton.setAttribute('aria-label', I18N.t(parado ? 'calidad.reproducir' : 'calidad.pausar'));
      }

      video.addEventListener('play', pintar);
      video.addEventListener('pause', pintar);
      pintar();
    }
  }

  var BOTE_GRAMOS = 120;
  var CUCHARADA_GRAMOS = 3;

  function cucharadasPorPeso(kg) {
    if (kg <= 10) return 1;
    if (kg <= 20) return 2;
    if (kg <= 30) return 3;
    if (kg <= 40) return 4;
    return 5;
  }

  function diasPorBote(cucharadas) {
    return Math.floor(BOTE_GRAMOS / (CUCHARADA_GRAMOS * cucharadas));
  }

  function iniciarCalculadora(ambito) {
    var slider = ambito.querySelector('#calc-peso');
    var salidaPeso = ambito.querySelector('#calc-peso-valor');
    var salidaCucharadas = ambito.querySelector('#calc-cucharadas');
    var salidaDias = ambito.querySelector('#calc-dias');

    if (!slider || !salidaPeso || !salidaCucharadas || !salidaDias) return;

    function actualizar() {
      var kg = Number(slider.value);
      var cucharadas = cucharadasPorPeso(kg);

      salidaPeso.textContent = kg;
      salidaCucharadas.textContent = cucharadas;
      salidaDias.textContent = diasPorBote(cucharadas);
    }

    slider.addEventListener('input', actualizar);
    actualizar();
  }

  function iniciarMovimiento() {
    if (!('IntersectionObserver' in window)) return;

    var elementos = document.querySelectorAll('.anima');
    if (!elementos.length) return;

    document.documentElement.classList.add('con-anima');

    var observador = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (entrada) {
        if (!entrada.isIntersecting) return;
        entrada.target.classList.add('visible');
        observador.unobserve(entrada.target);
      });
    }, { rootMargin: '0px 0px -10% 0px' });

    elementos.forEach(function (el) { observador.observe(el); });
  }

  function iniciarMiniaturas() {
    var tira = document.querySelector('.pdp-miniaturas');
    if (!tira || !('IntersectionObserver' in window)) return;

    var enlaces = [].slice.call(tira.querySelectorAll('.pdp-miniatura'));
    if (!enlaces.length) return;

    var fotos = enlaces.map(function (a) {
      return document.querySelector(a.getAttribute('href'));
    });
    if (fotos.indexOf(null) >= 0) return;

    function marcar(i) {
      enlaces.forEach(function (a, n) {
        a.classList.toggle('pdp-miniatura--activa', n === i);
      });
    }

    var observador = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (e.isIntersecting) marcar(fotos.indexOf(e.target));
      });
    }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });

    fotos.forEach(function (f) { observador.observe(f); });
  }

  function iniciarZoom() {
    var capa = document.querySelector('[data-zoom]');
    var abrir = document.querySelector('[data-zoom-abrir]');
    if (!capa) return;

    var foto = capa.querySelector('[data-zoom-foto]');
    var cerrar = capa.querySelector('[data-zoom-cerrar]');
    var flechas = [].slice.call(capa.querySelectorAll('[data-zoom-ir]'));
    var fotos = [].slice.call(document.querySelectorAll('.pdp-galeria__foto'));
    if (!foto || !fotos.length) return;

    var abribles = fotos.slice(1);
    if (!abribles.length) return;

    var indice = 0;
    var ultimoFoco = null;

    function pintar() {
      indice = Math.max(0, Math.min(indice, abribles.length - 1));
      var origen = abribles[indice];

      foto.src = origen.currentSrc || origen.src;
      foto.alt = origen.alt || '';
      flechas.forEach(function (b) {
        var dir = Number(b.getAttribute('data-zoom-ir'));
        b.disabled = dir < 0 ? indice === 0 : indice === abribles.length - 1;
      });
    }

    function abre(n) {
      if (typeof n === 'number') {
        indice = n;
      } else {
        var activa = document.querySelector('.pdp-miniatura--activa');
        indice = activa ? Number(activa.getAttribute('data-mini')) - 2 : 0;
      }
      pintar();
      ultimoFoco = document.activeElement;
      capa.hidden = false;
      document.body.classList.add('sin-scroll');
      cerrar.focus();
    }

    function cierra() {
      capa.hidden = true;
      document.body.classList.remove('sin-scroll');
      if (ultimoFoco && document.contains(ultimoFoco)) ultimoFoco.focus();
      ultimoFoco = null;
    }

    if (abrir) abrir.addEventListener('click', function () { abre(); });
    cerrar.addEventListener('click', cierra);

    var conRaton = window.matchMedia('(min-width: 1000px) and (hover: hover)');

    abribles.forEach(function (im, i) {
      im.addEventListener('click', function () {
        if (conRaton.matches) abre(i);
      });
    });

    if (abrir && 'IntersectionObserver' in window) {
      var pila = document.querySelector('.pdp-galeria__pila');
      new IntersectionObserver(function (e) {
        abrir.hidden = e[0].isIntersecting;
      }, { root: pila, threshold: 0.6 }).observe(fotos[0]);
    }

    lupa(conRaton, capa, abribles);

    flechas.forEach(function (b) {
      b.addEventListener('click', function () {
        indice += Number(b.getAttribute('data-zoom-ir'));
        pintar();
      });
    });

    capa.addEventListener('click', function (e) {
      if (e.target === capa) cierra();
    });

    document.addEventListener('keydown', function (e) {
      if (capa.hidden) return;
      if (e.key === 'Escape') cierra();
      if (e.key === 'ArrowLeft')  { indice -= 1; pintar(); }
      if (e.key === 'ArrowRight') { indice += 1; pintar(); }
    });
  }

  var TAPA_BOTE = 0.196;

  function iniciarVets() {
    document.querySelectorAll('[data-vets]').forEach(function (sec) {
      var caras = [].slice.call(sec.querySelectorAll('[data-vet-cara]'));
      function elegir(i, foco) {
        caras.forEach(function (c, j) {
          var on = j === i;
          c.setAttribute('aria-selected', on ? 'true' : 'false');
          c.tabIndex = on ? 0 : -1;
          if (on && foco) c.focus();
        });
        sec.querySelectorAll('[data-vet-panel]').forEach(function (p) {
          p.hidden = +p.getAttribute('data-vet-panel') !== i;
        });
      }
      caras.forEach(function (c, i) {
        c.addEventListener('click', function () { elegir(i); });
        c.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            e.preventDefault();
            var n = (i + (e.key === 'ArrowRight' ? 1 : caras.length - 1)) % caras.length;
            elegir(n, true);
          }
        });
      });
    });
  }

  function iniciarBarraSeed() {
    var sk = document.querySelector('[data-sk]');
    if (!sk) return;
    var boton = sk.querySelector('.sk__boton');
    var encendida = false, reloj = 0, pendiente = false;

    function referencia() {
      return document.querySelector('.pdp-compra .pagos--ficha') ||
             document.querySelector('.pagos--ficha');
    }
    var real = document.querySelector('.pdp-compra__form .boton--principal') ||
               document.querySelector('.pdp-datos .boton--principal');
    function navAlto() {
      return parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--nav-alto')) || 0;
    }
    function poner(on) {
      if (on === encendida) return;
      encendida = on;
      clearTimeout(reloj);
      document.documentElement.classList.toggle('sk-visible', on);
      if (on) {
        sk.classList.remove('sk--sale');
        sk.classList.add('sk--on');
      } else {
        sk.classList.add('sk--sale');
        reloj = setTimeout(function () { sk.classList.remove('sk--on', 'sk--sale'); }, 320);
      }
      if (boton) boton.tabIndex = on ? 0 : -1;
    }

    var pie = document.getElementById('pie') || document.querySelector('footer');
    if (pie && pie.parentNode) {
      var ancla = document.createElement('div');
      ancla.className = 'sk-ancla';
      pie.parentNode.insertBefore(ancla, pie);
      ancla.appendChild(sk);
    }
    function mirar() {
      pendiente = false;
      var nav = navAlto();
      var l = referencia();
      if (l && l.offsetHeight) {
        var top = l.getBoundingClientRect().bottom, y = window.scrollY;

        var pegada = y > (mirar.y || 0) && Math.abs(top - (mirar.top || 0)) < 1 && top < nav + 160;
        if (y < (mirar.y || 0) && Math.abs(top - (mirar.top || 0)) < 1 && encendida && top < nav + 160) pegada = true;
        mirar.y = y; mirar.top = top;
        poner(top <= nav + 40 || pegada);
        return;
      }
      if (real) poner(real.getBoundingClientRect().bottom <= nav);
    }
    function remedir() { mirar(); }

    function pedir() {
      if (!pendiente) { pendiente = true; requestAnimationFrame(mirar); }
    }
    window.addEventListener('scroll', pedir, { passive: true, capture: true });
    document.addEventListener('scroll', pedir, { passive: true, capture: true });
    var ref0 = referencia();
    if (ref0 && 'IntersectionObserver' in window) {
      var umbrales = [];
      for (var u = 0; u <= 20; u++) umbrales.push(u / 20);
      new IntersectionObserver(pedir, {
        threshold: umbrales,
        rootMargin: (-(navAlto() + 40)) + 'px 0px 0px 0px'
      }).observe(ref0);
      if (real) new IntersectionObserver(pedir, { threshold: [0, 1] }).observe(real);
    }
    window.addEventListener('resize', remedir);
    window.addEventListener('load', remedir);

    var col = document.querySelector('.pdp-datos') || document.querySelector('.pdp-compra');
    if (col && 'MutationObserver' in window) {
      var cola = 0;
      new MutationObserver(function () {
        clearTimeout(cola); cola = setTimeout(remedir, 150);
      }).observe(col, { childList: true, subtree: true });
    }
    mirar();
  }

  function vestirBarraCompra() {

    var envoltorio = document.querySelector('.sticky-atc-wrapper');
    if (!envoltorio) {
      if (vestirBarraCompra.intentos === undefined) vestirBarraCompra.intentos = 0;
      if (++vestirBarraCompra.intentos > 20) return;
      setTimeout(vestirBarraCompra, 300);
      return;
    }

    var real = document.querySelector('.pdp-datos .boton--principal') ||
               document.querySelector('form[action*="/cart/add"] .boton--principal');

    var ancho = window.matchMedia('(min-width: 1000px)');

    if (real) {
      var navAlto = parseFloat(getComputedStyle(document.documentElement)
                      .getPropertyValue('--nav-alto')) || 0;

      var mirando = new IntersectionObserver(function (e) {
        var ent = e[0];
        var pasado = !ent.isIntersecting && ent.boundingClientRect.bottom <= navAlto;
        envoltorio.classList.toggle('barra--fuera', pasado && ancho.matches);
      }, { threshold: 0, rootMargin: (-navAlto) + 'px 0px 0px 0px' });
      mirando.observe(real);
    }

    function revisar() {
      if (!ancho.matches) envoltorio.classList.remove('barra--fuera');
    }
    if (ancho.addEventListener) ancho.addEventListener('change', revisar);

    function precioDeUnBote() {
      var p = document.querySelector('[data-cp] .cp__pack');
      var c = p && Number(p.getAttribute('data-una'));
      if (!c) return '';
      return (c / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
    }

    function rotuloBarra() {
      var I = window.VEVVIA_I18N;
      var txt = (I && I.diccionario && I.t('pdp.anadir')) || '';
      if (!txt) return '';
      var pr = precioDeUnBote();
      return pr ? txt + ' · ' + pr : txt;
    }

    function vestirClon() {
      var clon = envoltorio.querySelector('button[name="add"]');
      if (!clon) return;
      var quiere = rotuloBarra();
      if (!quiere) return;

      var suyo = clon.querySelector('[data-add-to-cart-text]');
      if (suyo && suyo.textContent.trim() !== quiere) suyo.textContent = quiere;

      var accion = clon.querySelector('[data-cp-accion]');
      var I = window.VEVVIA_I18N;
      var solo = (I && I.diccionario && I.t('pdp.anadir')) || '';
      if (accion && solo && accion.textContent.trim() !== solo) accion.textContent = solo;

      var precio = clon.querySelector('.pdp-boton__precio');
      var pr = precioDeUnBote();
      if (precio && pr && precio.textContent.trim() !== pr) precio.textContent = pr;
    }

    vestirClon();
    new MutationObserver(vestirClon).observe(envoltorio, {
      childList: true, subtree: true, characterData: true
    });
    if (window.VEVVIA_I18N && window.VEVVIA_I18N.listo) {
      window.VEVVIA_I18N.listo.then(vestirClon);
    }
  }

  function alinearCompra() {
    var izq  = document.querySelector('.pdp-info');
    var der  = document.querySelector('.pdp-datos');
    var foto = document.querySelector('.pdp-galeria__foto img') ||
               document.querySelector('.pdp-galeria img');
    if (!izq || !der || !foto) return;

    var ancho = window.matchMedia('(min-width: 1000px)');

    function altura(el) {
      var y = 0;
      while (el) { y += el.offsetTop; el = el.offsetParent; }
      return y;
    }

    var columnas = [[izq, '--info-arranque'], [der, '--datos-arranque']];

    function poner() {

      if (!ancho.matches) {
        columnas.forEach(function (c) {
          c[0].style.removeProperty(c[1]);
          c[0].style.removeProperty('top');
          c[0].style.removeProperty('max-height');
          c[0].classList.remove('pdp-col--desborda');
        });
        return;
      }

      if (!foto.offsetHeight) return;

      columnas.forEach(function (c) { c[0].style.setProperty(c[1], '0px'); });
      var tapa = altura(foto) + foto.offsetHeight * TAPA_BOTE;

      var caja   = der.closest('section');
      var refDer = der.querySelector('.pdp-descriptor') || der.firstElementChild;
      if (caja && refDer) {
        tapa = Math.min(tapa, altura(caja) + (altura(refDer) - altura(der)));
      }

      columnas.forEach(function (c) {

        var ref = c[0].querySelector('.pdp-descriptor') || c[0].firstElementChild;
        if (!ref) return;

        var hueco = tapa - altura(ref);

        if (c[1] !== '--datos-arranque') hueco = Math.max(0, hueco);

        c[0].style.setProperty(c[1], Math.round(hueco) + 'px');
      });

      sincronizarPegado();
    }

    function sincronizarPegado() {
      var navAlto = parseFloat(getComputedStyle(document.documentElement)
                      .getPropertyValue('--nav-alto')) || 0;

      var arriba = columnas.map(function (c) {
        var y = 0, el = c[0];
        while (el) { y += el.offsetTop; el = el.offsetParent; }
        return y;
      });
      var base = Math.min.apply(null, arriba);

      var vh = window.innerHeight;

      var MARGEN_PEGADO = 24;

      columnas.forEach(function (c, i) {
        var col = c[0];
        var top = navAlto + (arriba[i] - base);
        col.style.top = Math.round(top) + 'px';

        if (col !== izq) {
          var alto = col.offsetHeight;
          var hueco = vh - top;
          if (alto > hueco) {
            col.style.top = Math.round(vh - alto - MARGEN_PEGADO) + 'px';
          }
          col.style.maxHeight = '';
          col.classList.remove('pdp-col--desborda');
          return;
        }

        var techo = Math.max(240, vh - top);
        col.style.maxHeight = Math.round(techo) + 'px';
        col.classList.toggle('pdp-col--desborda', col.scrollHeight > techo + 1);
      });
    }

    poner();
    window.addEventListener('resize', poner);
    if (ancho.addEventListener) ancho.addEventListener('change', poner);

    if (window.ResizeObserver) {
      var vigilante = new ResizeObserver(function () {
        if (ancho.matches) sincronizarPegado();
      });
      columnas.forEach(function (c) {
        for (var k = 0; k < c[0].children.length; k++) vigilante.observe(c[0].children[k]);
      });
    }

    if (!foto.complete) foto.addEventListener('load', poner);

    if (document.fonts && document.fonts.ready) document.fonts.ready.then(poner);
  }

  function lupa(conRaton, capa, abribles) {
    var pila = document.querySelector('.pdp-galeria__pila');
    var galeria = document.querySelector('.pdp-galeria');
    if (!pila || !galeria) return;

    var disco = null;
    var x = 0, y = 0, pedido = 0;

    function pinta() {
      pedido = 0;

      disco.style.transform = 'translate(' + (x - 28) + 'px,' + (y - 28) + 'px)';
    }

    function mueve(e) {
      x = e.clientX;
      y = e.clientY;
      if (!pedido) pedido = requestAnimationFrame(pinta);

      var vale = capa.hidden && abribles.indexOf(e.target) >= 0;
      disco.classList.toggle('pdp-lupa--vista', vale);
    }

    function sale() {
      disco.classList.remove('pdp-lupa--vista');
    }

    function monta() {
      if (disco) return;
      disco = document.createElement('div');
      disco.className = 'pdp-lupa';
      disco.setAttribute('aria-hidden', 'true');
      document.body.appendChild(disco);
      galeria.classList.add('pdp-galeria--lupa');
      pila.addEventListener('pointermove', mueve);
      pila.addEventListener('pointerleave', sale);

      pila.addEventListener('click', sale);
    }

    function desmonta() {
      if (!disco) return;
      pila.removeEventListener('pointermove', mueve);
      pila.removeEventListener('pointerleave', sale);
      pila.removeEventListener('click', sale);
      galeria.classList.remove('pdp-galeria--lupa');
      disco.remove();
      disco = null;
    }

    function segun() {
      if (conRaton.matches) monta(); else desmonta();
    }

    segun();

    if (conRaton.addEventListener) conRaton.addEventListener('change', segun);
    else if (conRaton.addListener) conRaton.addListener(segun);
  }

  function iniciarNavSolido() {
    var nav = document.querySelector(".nav");

    var heroe = document.querySelector('[data-heroe]');
    if (!nav) return;

    if (!('IntersectionObserver' in window)) { nav.classList.add('nav--solido'); return; }

    if (heroe) {
      var claro = heroe.hasAttribute('data-heroe-claro');
      var observador = new IntersectionObserver(function (entradas) {
        var dentro = entradas[0].isIntersecting;
        nav.classList.toggle('nav--solido', !dentro);
        nav.classList.toggle('nav--claro', claro && dentro);
      }, { rootMargin: '-72px 0px 0px 0px', threshold: 0 });
      observador.observe(heroe);
    } else {
      nav.classList.add('nav--solido');
    }

    function luz(color) {
      var m = color.match(/[\d.]+/g);
      if (!m || m.length < 3) return null;
      var a = m.length > 3 ? parseFloat(m[3]) : 1;
      if (a < 0.85) return null;
      function c(v) {
        v = v / 255;
        return v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
      }
      return 0.2126 * c(+m[0]) + 0.7152 * c(+m[1]) + 0.0722 * c(+m[2]);
    }

    var oscuras = [];
    [].slice.call(document.querySelectorAll('section, footer, aside, div')).forEach(function (el) {
      var r = el.getBoundingClientRect();

      if (r.width < window.innerWidth * 0.5 || r.height < 60) return;
      var L = luz(getComputedStyle(el).backgroundColor);
      if (L !== null && L < 0.2) oscuras.push(el);
    });

    [].slice.call(document.querySelectorAll('[data-nav-oscuro]')).forEach(function (el) {
      if (oscuras.indexOf(el) < 0) oscuras.push(el);
    });

    if (!oscuras.length) return;

    var encima = new Set();

    function mirarBanda() {
      var alto = nav.getBoundingClientRect().height || 72;
      return new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (e.isIntersecting) encima.add(e.target); else encima.delete(e.target);
        });
        nav.classList.toggle('nav--oscuro', encima.size > 0);
      }, {
        rootMargin: '-' + alto + 'px 0px -' +
                    Math.max(0, window.innerHeight - alto - 1) + 'px 0px',
        threshold: 0
      });
    }

    var vigia = mirarBanda();
    oscuras.forEach(function (s) { vigia.observe(s); });

    window.addEventListener('resize', function () {
      vigia.disconnect();
      encima.clear();
      vigia = mirarBanda();
      oscuras.forEach(function (s) { vigia.observe(s); });
    });
  }

  var PALETA_BUNDLE = [
    '.body{',
    '  --option-bg-color:#FAF5EA !important;',
    '  --option-bg-color-on-select:#F3E7DA !important;',
    '  --option-border-color:rgba(43,26,19,.28) !important;',
    '  --option-border-color-on-select:#AD563B !important;',
    '  --option-title-color:#5E2E20 !important;',
    '  --option-subtitle-color:#8A4029 !important;',
    '  --option-price-color:#5E2E20 !important;',
    '  --option-original-price-color:#8A4029 !important;',
    '  --title-color:#5E2E20 !important;',
    '  --title-decorate-line-color:rgba(43,26,19,.28) !important;',
    '  --title-decorate-line-thickness:1px !important;',
    '  --option-badge-background:#AD563B !important;',
    '  --option-badge-color:#FCFCD6 !important;',
    '  --product-variant-selector-border-color:rgba(43,26,19,.28) !important;',
    '  --subs-title-color:#5E2E20 !important;',
    '  --subs-subtitle-color:#8A4029 !important;',
    '  --subs-radio-button-border-color:rgba(43,26,19,.28) !important;',
    '  --subs-radio-button-border-color-on-select:#AD563B !important;',
    '  --subs-radio-button-bg-color:#FAF5EA !important;',
    '  --subs-radio-button-bg-color-on-select:#AD563B !important;',
    '  --subs-radio-button-text-color:#5E2E20 !important;',
    '  --subs-radio-button-text-color-on-select:#FCFCD6 !important;',
    '  --subs-discount-badge-bg-color:#AD563B !important;',
    '  --subs-discount-badge-text-color:#FCFCD6 !important;',
    '  --free-gift-bg-color:#FAF5EA !important;',
    '  --free-gift-bg-color-on-select:#AD563B !important;',
    '  --free-gift-text-color:#5E2E20 !important;',
    '  --free-gift-text-color-on-select:#FCFCD6 !important;',
    '  --free-gift-border-color:rgba(43,26,19,.28) !important;',
    '  --free-gift-border-color-on-select:#AD563B !important;',
    '  --mix-and-match-quantity-indicator-background-color:#AD563B !important;',
    '  --mix-and-match-quantity-indicator-text-color:#FCFCD6 !important;',
    '}',

    '.bundle-option .title{',
    '  font-family:"Aminute","Helvetica Neue",Helvetica,Arial,sans-serif !important;',
    '  font-weight:400 !important;',
    '}',

    '.bundle-option .header .price .price-total{',
    '  position:static !important;',
    '}',
    '.bundle-option .header .price .price-total .original{',
    '  position:absolute !important;',
    '  right:12px !important;',
    '  bottom:6px !important;',
    '  line-height:1 !important;',
    '}',

    '.bundle-option .select-indicator.outlined-circle{',
    '  background:#FAF5EA !important;',
    '  border-color:#FAF5EA !important;',
    '}',
    '.bundle-option-input:checked~.bundle-option-radio-label .select-indicator.outlined-circle{',
    '  background:#AD563B !important;',
    '  border-color:#F3E7DA !important;',
    '  box-shadow:0 0 0 2px #AD563B !important;',
    '}',

    '.bundle-option-radio-label .badge.active{',
    '  --option-badge-background:#5E2E20 !important;',
    '  --option-badge-color:#FCFCD6 !important;',
    '  background:#5E2E20 !important;',
    '  color:#FCFCD6 !important;',
    '}',
    '.bundle-option-radio-label .badge.active.ribbon:before,',
    '.bundle-option-radio-label .badge.active.ribbon:after{',
    '  background:#5E2E20 !important;',
    '}',

    '.bundle-option-input:checked~.bundle-option-radio-label .bundle-option-box{',
    '  border-width:2px !important;',
    '}',
    '.bundle-option-input:checked~.bundle-option-radio-label .title,',
    '.bundle-option-input:checked~.bundle-option-radio-label .price,',
    '.bundle-option-input:checked~.bundle-option-radio-label .price-total,',
    '.bundle-option-input:checked~.bundle-option-radio-label .discounted,',
    '.bundle-option-input:checked~.bundle-option-radio-label .discounted-value{',
    '  color:#5E2E20 !important;',
    '}',
    '.bundle-option-input:checked~.bundle-option-radio-label .subtitle,',
    '.bundle-option-input:checked~.bundle-option-radio-label .discounted-label,',
    '.bundle-option-input:checked~.bundle-option-radio-label .index-text{',
    '  color:#8A4029 !important;',
    '}',
    '.bundle-option-input:checked~.bundle-option-radio-label .original{',
    '  color:#8A4029 !important;',
    '}',

    '.bundle-option .header .title-badge.active,',
    '.bundle-option-input:checked~.bundle-option-radio-label .title-badge.active{',
    '  background:#DCEBD5 !important;',
    '  background-image:none !important;',
    '  color:#34502A !important;',
    '  font-weight:500 !important;',
    '}',

    '.bundle-option .benefits{',
    '  --benefits-icon-color:#5F7452 !important;',
    '}',
    '.bundle-option .benefits .benefit .benefit-icon{',
    '  color:#5F7452 !important;',
    '}',

    '.bundle-option-title,',
    '.bundle-header,',
    '.bundle-option-radio-label .badge,',
    '.bundle-option .selector-wrapper__summary-index,',
    '.bundle-option .title-badge{',
    '  font-weight:500 !important;',
    '}'
  ].join('\n');

  function aNumero(txt) {
    if (!txt) return NaN;
    var limpio = String(txt).replace(/[^\d.,]/g, '')
                            .replace(/\./g, '')
                            .replace(',', '.');
    return parseFloat(limpio);
  }

  function enEuros(n) {
    return n.toFixed(2).replace('.', ',') + ' €';
  }

  var reescribiendo = false;

  function ahorroEnEuros(raiz) {
    if (!raiz || reescribiendo) return;
    reescribiendo = true;
    try {
      var opciones = raiz.querySelectorAll('.bundle-option');
      for (var i = 0; i < opciones.length; i++) {
        var pildora = opciones[i].querySelector('.title-badge');
        if (!pildora || !pildora.textContent.trim()) continue;

        var antes   = aNumero((opciones[i].querySelector('.price-total .original') || {}).textContent);
        var despues = aNumero((opciones[i].querySelector('.price-total .discounted') || {}).textContent);
        if (isNaN(antes) || isNaN(despues)) continue;

        var ahorro = antes - despues;
        if (!(ahorro > 0.005)) continue;

        var texto = 'Ahorras ' + enEuros(ahorro);
        if (pildora.textContent !== texto) pildora.textContent = texto;
      }
    } finally {
      reescribiendo = false;
    }
  }

  var CAJITAS = [
    '.card .icon{display:none !important}',
    '.card{gap:2px !important}',
    '.card .title{',
    '  font-size:22px !important;',
    '  font-weight:500 !important;',
    '  line-height:22px !important;',
    '  font-variant-numeric:tabular-nums;',
    '  color:#5E2E20 !important;',
    '}',
    '.card .subtitle{',
    '  display:block !important;',
    '  font-size:11px !important;',
    '  line-height:14px !important;',
    '  color:#8A4029 !important;',
    '}'
  ].join('\n');

  function vestirCajitas() {
    var caja = document.querySelector('section-store--benefits-boxes-block');
    if (!caja || !caja.shadowRoot) return;

    function poner() {
      var raiz = caja.shadowRoot;
      if (!raiz || raiz.querySelector('#cajitas-vevvia')) return;
      var hoja = document.createElement('style');
      hoja.id = 'cajitas-vevvia';
      hoja.textContent = CAJITAS;
      raiz.appendChild(hoja);
    }

    poner();
    if (window.MutationObserver) {
      new MutationObserver(poner).observe(caja.shadowRoot, { childList: true });
    }
  }

  function vestirBundle() {
    var caja = document.querySelector('section-store--bundle-block');
    if (!caja || !caja.shadowRoot) return;

    function poner() {
      var raiz = caja.shadowRoot;
      if (!raiz) return;

      ahorroEnEuros(raiz);

      if (raiz.querySelector('#paleta-vevvia')) return;
      var hoja = document.createElement('style');
      hoja.id = 'paleta-vevvia';
      hoja.textContent = PALETA_BUNDLE;
      raiz.appendChild(hoja);
    }

    poner();

    if (window.MutationObserver) {
      new MutationObserver(poner).observe(caja.shadowRoot, { childList: true, subtree: true });
    }
  }

  function botonesQueEligen() {
    document.addEventListener('click', function (ev) {
      var b = ev.target.closest && ev.target.closest('[data-elige-pack]');
      if (!b) return;
      var caja = document.querySelector('[data-cp]');
      var destino = document.getElementById('comprar');
      if (!caja || !destino) return;
      ev.preventDefault();
      var n = b.getAttribute('data-elige-pack');
      var pack = caja.querySelector('.cp__pack[data-n="' + n + '"] input[name="formato"]');
      if (pack && !pack.checked) { pack.checked = true; pack.dispatchEvent(new Event('change', { bubbles: true })); }
      var modo = caja.querySelector('input[name="cp_modo"][value="' + (b.getAttribute('data-elige-modo') || 'sus') + '"]');
      if (modo && !modo.checked) { modo.checked = true; modo.dispatchEvent(new Event('change', { bubbles: true })); }
      var quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      destino.scrollIntoView({ behavior: quieto ? 'auto' : 'smooth', block: 'start' });
    });
  }

  function anillosCifras() {
    var z = document.querySelector('[data-cifras]');
    if (!z || !('IntersectionObserver' in window)) return;
    z.classList.add('por-ver');
    var io = new IntersectionObserver(function (es) {
      if (!es[0].isIntersecting) return;
      z.classList.add('en-vista');
      requestAnimationFrame(function () { requestAnimationFrame(function () { z.classList.remove('por-ver'); }); });
      io.disconnect();
    }, { threshold: 0.35 });
    io.observe(z);
  }

  function estrellasAResenas() {
    var destino = document.getElementById('resenas');
    if (!destino) return;
    document.addEventListener('click', function (ev) {
      var t = ev.target.closest && ev.target.closest('section-store--review-summary-block');
      if (!t) return;
      ev.preventDefault();
      var quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      destino.scrollIntoView({ behavior: quieto ? 'auto' : 'smooth', block: 'start' });
    });

    var marcar = function () {
      document.querySelectorAll('section-store--review-summary-block:not([data-vv-enlace])').forEach(function (b) {
        b.setAttribute('data-vv-enlace', '');
        b.setAttribute('role', 'link');
        b.setAttribute('tabindex', '0');
        b.setAttribute('aria-label', 'Ver las reseñas');
        b.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); b.click(); }
        });
      });
    };
    marcar();
    setTimeout(marcar, 1500);
    setTimeout(marcar, 4000);
  }

  function iniciarSenales() {
    var zona = document.querySelector('.pdp-senales');
    if (!zona) return;

    var casillas = zona.querySelectorAll('.pdp-senal__casilla');
    var rotulo   = zona.querySelector('[data-senales-cuenta]');
    var cierre   = zona.querySelector('[data-senales-cierre]');
    if (!casillas.length || !rotulo) return;

    var total = casillas.length;

    function texto(clave) {
      return (window.VEVVIA_I18N && window.VEVVIA_I18N.t(clave)) || '';
    }

    function contar() {
      var n = 0;
      for (var i = 0; i < casillas.length; i++) if (casillas[i].checked) n++;

      if (cierre) cierre.classList.toggle('hay', n > 0);

      if (n === 0) {
        rotulo.setAttribute('data-i18n', 'senales.marcar');
        rotulo.textContent = texto('senales.marcar');
        rotulo.classList.remove('pdp-senales__cuenta--hay');
        return;
      }

      rotulo.removeAttribute('data-i18n');
      var clave = n === 1 ? 'senales.cuentaUna' : 'senales.cuenta';
      rotulo.textContent = String(texto(clave))
        .replace('{n}', n)
        .replace('{total}', total);
      rotulo.classList.add('pdp-senales__cuenta--hay');
    }

    for (var j = 0; j < casillas.length; j++) {
      casillas[j].addEventListener('change', contar);
    }

    contar();
  }

  var KLAVIYO_ID    = '';
  var KLAVIYO_LISTA = '';

  function iniciarQuiz() {
    var zona = document.querySelector('.quiz');
    if (!zona) return;

    var pantallas = zona.querySelectorAll('[data-quiz-pantalla]');
    var barra     = zona.querySelector('[data-quiz-barra]');
    var numPaso   = zona.querySelector('[data-quiz-paso]');
    var cabecera  = zona.querySelector('.quiz__cabecera');
    var entrada   = zona.querySelector('[data-quiz-entrada]');
    var campoN    = zona.querySelector('#quiz-nombre');
    var rango     = zona.querySelector('#quiz-peso');
    var salidaP   = zona.querySelector('[data-quiz-peso]');
    var lista     = zona.querySelector('.quiz__senales');
    if (!pantallas.length || !lista) return;

    var paso = 1;
    var TOTAL = 3;

    function texto(c) {
      return (window.VEVVIA_I18N && window.VEVVIA_I18N.t(c)) || '';
    }

    var senales = [];
    lista.querySelectorAll('.quiz__senal').forEach(function (li) {
      var cas = li.querySelector('.quiz__senal-casilla');
      var tit = li.querySelector('.quiz__senal-titulo');
      if (cas && tit) senales.push({ casilla: cas, texto: tit });
    });

    function pintar() {
      for (var i = 0; i < pantallas.length; i++) {
        pantallas[i].hidden = Number(pantallas[i].getAttribute('data-quiz-pantalla')) !== paso;
      }

      if (entrada)  entrada.hidden  = paso !== 1;

      if (cabecera) cabecera.hidden = paso > TOTAL;
      if (numPaso)  numPaso.textContent = String(Math.min(paso, TOTAL));
      if (barra)    barra.style.width = (Math.min(paso, TOTAL) / TOTAL * 100) + '%';
      zona.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function nombre() {
      return (campoN && campoN.value.trim()) || '';
    }

    function pintarNombre() {
      var n = nombre();
      zona.querySelectorAll('[data-quiz-nombre]').forEach(function (e) { e.textContent = n; });
    }

    function marcadas() {
      return senales.filter(function (s) { return s.casilla.checked; })
                    .map(function (s) { return s.texto.textContent.trim(); });
    }

    function pintarResultado() {
      var kg = Number(rango.value);
      var c  = cucharadasPorPeso(kg);
      var d  = diasPorBote(c);

      zona.querySelector('[data-quiz-cucharadas]').textContent = String(c);
      zona.querySelector('[data-quiz-cucharadas-t]').textContent =
        texto(c === 1 ? 'quiz.rCucharada' : 'quiz.rCucharadas');
      zona.querySelector('[data-quiz-dias]').textContent = String(d);

      var m = marcadas();
      var caja = zona.querySelector('[data-quiz-mirar]');
      var ul   = zona.querySelector('[data-quiz-mirar-lista]');
      caja.hidden = m.length === 0;
      ul.innerHTML = '';
      m.forEach(function (x) {
        var li = document.createElement('li');
        li.textContent = x;
        ul.appendChild(li);
      });
    }

    zona.querySelectorAll('[data-quiz-seguir]').forEach(function (b) {
      b.addEventListener('click', function () {

        if (paso === 3) { pintarNombre(); pintarResultado(); }
        if (paso === 1) pintarNombre();
        paso += 1;
        pintar();
      });
    });

    zona.querySelectorAll('[data-quiz-atras]').forEach(function (b) {
      b.addEventListener('click', function () { paso = Math.max(1, paso - 1); pintar(); });
    });

    if (campoN) campoN.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); pintarNombre(); paso = 2; pintar(); }
    });

    if (rango && salidaP) {
      var verPeso = function () { salidaP.textContent = rango.value; };
      rango.addEventListener('input', verPeso);
      verPeso();
    }

    var form  = zona.querySelector('[data-quiz-form]');
    var aviso = zona.querySelector('[data-quiz-aviso]');

    function decir(clave, clase) {
      if (!aviso) return;
      aviso.textContent = texto(clave);
      aviso.className = 'quiz__aviso' + (clase ? ' quiz__aviso--' + clase : '');
    }

    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      var correo = form.querySelector('[name=email]').value.trim();
      var ok     = form.querySelector('[name=consentimiento]').checked;

      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(correo) || !ok) { decir('quiz.cFalta', 'mal'); return; }

      var kg = Number(rango.value);
      var c  = cucharadasPorPeso(kg);
      var d  = diasPorBote(c);
      var fin = new Date(Date.now() + d * 86400000).toISOString().slice(0, 10);

      var propiedades = {
        nombre_perro:   nombre(),
        peso_kg:        kg,
        cucharadas_dia: c,
        dias_bote:      d,
        fecha_fin_bote: fin,
        senales:        marcadas()
      };

      if (!KLAVIYO_ID || !KLAVIYO_LISTA) {

        console.warn('[quiz] Klaviyo sin configurar. Se habria enviado:', correo, propiedades);
        decir('quiz.cError', 'mal');
        return;
      }

      decir('quiz.cEnviando');
      var boton = form.querySelector('button[type=submit]');
      if (boton) boton.disabled = true;

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_ID, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: { email: correo, properties: propiedades }
                }
              }
            },
            relationships: { list: { data: { type: 'list', id: KLAVIYO_LISTA } } }
          }
        })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('klaviyo ' + r.status);
          decir('quiz.cHecho', 'bien');
          form.querySelector('.quiz__correo-campo').hidden = true;
          form.querySelector('.quiz__consentimiento').hidden = true;
          if (boton) boton.hidden = true;
        })
        .catch(function (err) {
          console.error('[quiz]', err);
          decir('quiz.cError', 'mal');
          if (boton) boton.disabled = false;
        });
    });

    pintar();
  }

  var APPSTLE_ES = {
    'Purchase Options': 'Cómo lo quieres',
    'Purchase options': 'Cómo lo quieres',
    'One time purchase': 'Compra única',
    'One-time purchase': 'Compra única',
    'Single purchase': 'Compra única',
    'Subscription': 'Suscripción mensual',
    'Subscribe & Save': 'Suscríbete y ahorra',
    'Subscribe and Save': 'Suscríbete y ahorra',
    'Subscription detail': 'Cómo funciona',
    'Subscription details': 'Cómo funciona',
    'DELIVERY FREQUENCY': 'Frecuencia de entrega',
    'Delivery Frequency': 'Frecuencia de entrega',
    'Delivery frequency': 'Frecuencia de entrega',
    'Have complete control of your subscriptions':
      'Tú mandas: puedes pausarla, cambiar la fecha o cancelarla cuando quieras.'
  };

  function appstleEnEspanol() {
    var w = document.querySelector('[id^="appstle_subscription_widget"]');
    if (!w) return;

    var mirador = document.createTreeWalker(w, NodeFilter.SHOW_TEXT, null);
    var n, cambios = 0;
    while ((n = mirador.nextNode())) {
      var t = n.nodeValue.trim();
      if (!t || !APPSTLE_ES[t]) continue;
      n.nodeValue = n.nodeValue.replace(t, APPSTLE_ES[t]);
      cambios++;
    }
    return cambios;
  }

  function vestirSuscripcion() {
    var w = document.querySelector('[id^="appstle_subscription_widget"]');
    if (!w) {

      var espera = new MutationObserver(function () {
        if (document.querySelector('[id^="appstle_subscription_widget"]')) {
          espera.disconnect();
          vestirSuscripcion();
        }
      });
      espera.observe(document.body, { childList: true, subtree: true });
      return;
    }

    appstleEnEspanol();

    var vigia = new MutationObserver(function () {
      vigia.disconnect();
      appstleEnEspanol();
      vigia.observe(w, { childList: true, subtree: true, characterData: true });

      document.dispatchEvent(new CustomEvent('appstle:repintado'));
    });
    vigia.observe(w, { childList: true, subtree: true, characterData: true });
  }

  function elegirFormato() {
    var caja = document.querySelector('[data-formatos]');
    if (!caja) return;

    var form   = document.querySelector('.pdp-compra__form');
    var oculto = form && form.querySelector('[name="id"]');
    var precio = document.querySelector('.pdp-boton__precio');
    if (!oculto) return;

    function aplicar(radio) {
      if (!radio) return;
      oculto.value = radio.value;
      if (precio && radio.getAttribute('data-precio')) {
        precio.textContent = radio.getAttribute('data-precio');
      }

      try {
        oculto.dispatchEvent(new Event('change', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('variant:changed', {
          detail: { variant: { id: Number(radio.value) } }
        }));
        document.dispatchEvent(new CustomEvent('appstle:variant:changed', {
          detail: { variantId: Number(radio.value) }
        }));
      } catch (e) {}
    }

    function acercarBoton() {
      if (!ancho.matches) return;

      var btn = document.querySelector('.pdp-compra__form .boton--principal');
      if (!btn) return;

      var navAlto = parseFloat(getComputedStyle(document.documentElement)
                      .getPropertyValue('--nav-alto')) || 0;
      var r = btn.getBoundingClientRect();

      if (r.top >= navAlto + 8 && r.bottom <= window.innerHeight - 8) return;

      var quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      btn.scrollIntoView({ block: 'center', behavior: quieto ? 'auto' : 'smooth' });
    }

    var ancho = window.matchMedia('(min-width: 1000px)');

    caja.addEventListener('change', function (ev) {
      var r = ev.target;
      if (!r || r.name !== 'formato') return;
      aplicar(r);
      acercarBoton();
    });

    aplicar(caja.querySelector('input[name="formato"]:checked'));
  }

  function compraPacks() {
    var caja = document.querySelector('[data-cp]');
    if (!caja) return;
    var form = document.querySelector('.pdp-compra__form');
    var plan = form && form.querySelector('[data-cp-plan]');
    var accion = form && form.querySelector('[data-cp-accion]');
    var precioBoton = document.querySelector('.pdp-boton__precio');
    var I = window.VEVVIA_I18N;
    var t = function (k) { return I && I.diccionario ? I.t(k) : ''; };
    var base = Number(caja.getAttribute('data-base')) || 0;

    var euros = function (c) {
      return (c / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
    };

    function modo() {
      var m = caja.querySelector('input[name="cp_modo"]:checked');
      return m ? m.value : 'una';
    }

    var modoTocado = false;
    function modoPorPack() {
      if (modoTocado) return;
      var el = caja.querySelector('input[name="formato"]:checked');
      var p = el && el.closest('.cp__pack');
      if (!p) return;
      var quiere = Number(p.getAttribute('data-n')) > 1 && planDe(p) ? 'sus' : 'una';
      var r = caja.querySelector('input[name="cp_modo"][value="' + quiere + '"]');
      if (r && !r.checked) r.checked = true;
    }

    var grupoFreq = caja.querySelector('[data-cp-freq]');
    function frecuencia() {
      return grupoFreq ? (Number(grupoFreq.getAttribute('data-f')) || 0) : 0;
    }

    function planDe(p) {
      if (!p) return '';
      var l = (p.getAttribute('data-planes') || '').split(',').filter(Boolean);
      return l[frecuencia()] || l[0] || p.getAttribute('data-plan') || '';
    }

    function radiosAppstle() {
      if (!form) return null;
      var r = {
        una: form.querySelector('.appstle_one_time_details_wrapper input[name="selling_plan"]'),
        sus: form.querySelector('.appstle_subscription_radio_wrapper input[name="selling_plan"]')
      };
      return (r.una || r.sus) ? r : null;
    }

    var forzados = 0, desde = 0;

    function fijarPlan(idPlan) {
      var r = radiosAppstle();

      if (!r) {

        if (plan) { plan.value = idPlan || ''; plan.disabled = !idPlan; }
        return;
      }

      if (plan) plan.disabled = true;

      var diana = idPlan ? r.sus : r.una;
      if (!diana) return;

      if (idPlan && diana.value !== idPlan) diana.value = idPlan;

      var sel = idPlan && form.querySelector('select.appstle_select');
      if (sel && sel.value !== idPlan &&
          [].some.call(sel.options, function (o) { return o.value === idPlan; })) sel.value = idPlan;

      if (diana.checked) return;

      var ahora = Date.now();
      if (ahora - desde > 2000) { forzados = 0; desde = ahora; }
      if (++forzados > 12) return;

      diana.checked = true;
      diana.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function pintar(animar) {
      var hacer = function () {
        var m = modo();
        var elegido = caja.querySelector('input[name="formato"]:checked');
        var packElegido = elegido && elegido.closest('.cp__pack');

        caja.querySelectorAll('.cp__pack').forEach(function (p) {
          var n = Number(p.getAttribute('data-n'));
          var pr = Number(p.getAttribute(m === 'sus' ? 'data-sus' : 'data-una'));
          var ahorro = base * n - pr;
          p.querySelector('[data-cp-precio]').textContent = euros(pr);
          p.querySelector('[data-cp-ahorro]').textContent = ahorro > 50 ? t('pdp.cp.ahorras') + ' ' + euros(ahorro) : '';
          p.querySelector('[data-cp-porbote]').textContent = euros(pr / n) + ' ' + t('pdp.cp.porBote');
        });

        if (packElegido) {
          var una = Number(packElegido.getAttribute('data-una'));
          var sus = Number(packElegido.getAttribute('data-sus'));
          var idPlan = planDe(packElegido);

          var pUna = caja.querySelector('[data-cp-p-una]');
          var pSus = caja.querySelector('[data-cp-p-sus]');
          if (pUna) pUna.textContent = euros(una);

          var nPack = Number(packElegido.getAttribute('data-n')) || 1;
          var sueltos = base * nPack;

          if (pSus) pSus.innerHTML = '<b>' + euros(sus) + '</b>' + (sus < sueltos ? '<s>' + euros(sueltos) + '</s>' : '');

          if (pUna) pUna.innerHTML = '<b>' + euros(una) + '</b>' + (una < sueltos ? '<s>' + euros(sueltos) + '</s>' : '');
          var uSub = caja.querySelector('[data-cp-una-sub]');
          if (uSub) {
            if (una < sueltos) {
              uSub.textContent = t('pdp.cp.famSubAhorro').replace('{pb}', euros(Math.round(una / nPack))).replace('{eur}', euros(sueltos - una));
              uSub.hidden = false;
            } else {
              uSub.textContent = '';
              uSub.hidden = true;
            }
          }

          var fSub = caja.querySelector('[data-cp-fam-sub]');
          if (fSub) fSub.textContent = sus < sueltos
            ? t('pdp.cp.famSubAhorro').replace('{pb}', euros(Math.round(sus / nPack))).replace('{eur}', euros(sueltos - sus))
            : t('pdp.cp.famSubIgual');
          var reg = caja.querySelector('[data-cp-regalo]');
          if (reg) reg.innerHTML = '<b>' + t('pdp.cp.regaloA').replace('{eur}', euros(Math.floor(sus * 0.10))) + '</b> ' + t('pdp.cp.regaloB');

          var sSal = caja.querySelector('[data-cp-sus-saldo]');
          if (sSal && t('pdp.cp.susSaldo')) {
            sSal.innerHTML = t('pdp.cp.susSaldo')
              .replace('{freq}', t('pdp.cp.freq' + (frecuencia() + 1)))
              .replace('{eur}', '<b>' + euros(Math.floor(sus * 0.10)) + '</b>');
          }
          var pct = sueltos ? Math.round((1 - sus / sueltos) * 100) : 0;
          var em = caja.querySelector('[data-cp-pct]');
          if (em) em.textContent = pct > 0 ? '−' + pct + ' %' : '';

          var enSus = m === 'sus' && idPlan;
          fijarPlan(enSus ? idPlan : '');

          var cadaCuanto = enSus ? ' ' + t('pdp.cp.freq' + (frecuencia() + 1)) : '';
          if (precioBoton) precioBoton.textContent = euros(enSus ? sus : una) + cadaCuanto;
          var nota = document.querySelector('[data-cp-nota]');
          if (nota) {
            nota.hidden = !enSus;
            if (enSus) nota.textContent = t('pdp.cp.notaSus').replace('{eur}', euros(sus)).replace('{freq}', t('pdp.cp.freq' + (frecuencia() + 1)));
          }

          caja.setAttribute('data-modo', enSus ? 'sus' : 'una');
          var hueco = caja.querySelector('[data-cp-slot="' + (enSus ? 'sus' : 'una') + '"]');
          if (form && hueco && form.parentNode !== hueco) hueco.appendChild(form);
          var clave = enSus ? 'pdp.cp.suscribirme' : 'pdp.anadir';
          if (accion) {
            accion.setAttribute('data-i18n', clave);
            if (t(clave)) accion.textContent = t(clave);
          }

          var visible = form && form.querySelector('[data-add-to-cart-text]');
          if (visible && t(clave)) {

            if (enSus && caja.querySelector('[data-cp-slot]')) {
              visible.innerHTML = t('pdp.cp.unirmeA') + ' <span class="marca">vevvia</span> ' + t('pdp.cp.unirmeB');
            } else {
              visible.textContent = t(clave) + ' · ' + euros(enSus ? sus : una) + cadaCuanto;
            }
          }

          var lista = caja.querySelector('[data-cp-incluye]');
          if (lista) {
            var items = [].map.call(packElegido.querySelectorAll('.cp__fuente span'), function (s) { return s.textContent.trim(); })
              .filter(Boolean);
            lista.innerHTML = '';
            items.forEach(function (txt, i) {
              var li = document.createElement('li');
              li.textContent = txt;
              li.style.animationDelay = (i * 60) + 'ms';
              lista.appendChild(li);
            });
          }
        }
        caja.classList.remove('cp--cambiando');
      };
      var quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (animar && !quieto) { caja.classList.add('cp--cambiando'); setTimeout(hacer, 170); }
      else hacer();
    }

    function transicion(fn) {
      var quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!document.startViewTransition || quieto || !caja.querySelector('[data-cp-slot]')) return fn();
      try { document.startViewTransition(fn); } catch (e) { fn(); }
    }

    caja.addEventListener('change', function (ev) {
      var n = ev.target && ev.target.name;
      if (n !== 'formato' && n !== 'cp_modo') return;
      forzados = 0;
      if (n === 'cp_modo') {
        modoTocado = true;
        return transicion(function () { pintar(false); });
      }
      var antes = modo();
      modoPorPack();
      if (modo() !== antes) return transicion(function () { pintar(false); });
      pintar(true);
    });

    function elegirFrecuencia(b) {
      if (!grupoFreq || !b) return;
      grupoFreq.setAttribute('data-f', b.getAttribute('data-f'));
      grupoFreq.querySelectorAll('.cp__freqB').forEach(function (x) {
        var si = x === b;
        x.setAttribute('aria-checked', si ? 'true' : 'false');
        x.tabIndex = si ? 0 : -1;
      });
      forzados = 0;
      modoTocado = true;
      var rSus = caja.querySelector('input[name="cp_modo"][value="sus"]');
      if (rSus && !rSus.checked) {
        rSus.checked = true;
        rSus.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        pintar(false);
      }
    }
    if (grupoFreq) {
      grupoFreq.addEventListener('click', function (ev) {
        ev.preventDefault();
        elegirFrecuencia(ev.target.closest('.cp__freqB'));
      });
      grupoFreq.addEventListener('keydown', function (ev) {
        if (ev.key !== 'ArrowRight' && ev.key !== 'ArrowLeft') return;
        ev.preventDefault();
        var bs = grupoFreq.querySelectorAll('.cp__freqB');
        var n = (frecuencia() + (ev.key === 'ArrowRight' ? 1 : bs.length - 1)) % bs.length;
        elegirFrecuencia(bs[n]);
        bs[n].focus();
      });
    }

    document.addEventListener('appstle:repintado', function () {
      var elegido = caja.querySelector('input[name="formato"]:checked');
      var p = elegido && elegido.closest('.cp__pack');
      var id = planDe(p);
      fijarPlan(modo() === 'sus' && id ? id : '');
    });

    try {
      if (new URLSearchParams(location.search).get('modo') === 'family') {
        var rFam = caja.querySelector('input[name="cp_modo"][value="sus"]');
        if (rFam) { rFam.checked = true; modoTocado = true; }
      }
    } catch (e) {   }
    modoPorPack();

    pintar(false);
    if (I && I.listo) I.listo.then(function () { pintar(false); });

    var intentos = 0;
    var vigia = setInterval(function () {
      intentos++;
      var elegido = caja.querySelector('input[name="formato"]:checked');
      var p = elegido && elegido.closest('.cp__pack');
      var id = planDe(p);
      var quiere = modo() === 'sus' && id ? id : '';
      forzados = 0;
      fijarPlan(quiere);
      var r = radiosAppstle();
      var ok = r && (quiere ? (r.sus && r.sus.checked) : (r.una && r.una.checked));
      if ((ok && intentos > 6) || intentos > 40) clearInterval(vigia);
    }, 250);
  }

  function iniciarAuraFamily() {
    var root = document.querySelector('[data-vf-fondo]');
    if (!root) return;
    var pagina = root.parentElement;
    var cv = root.querySelector('.vfx-aura__lienzo'), cx = cv.getContext('2d');
    var gv = root.querySelector('.vfx-aura__grano'), gx = gv.getContext('2d');
    var mv = document.createElement('canvas'), mx = mv.getContext('2d');
    var quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var ruido = document.createElement('canvas'); ruido.width = ruido.height = 180;
    (function () {
      var x = ruido.getContext('2d'), d = x.createImageData(180, 180);
      for (var i = 0; i < d.data.length; i += 4) {
        var v = Math.random() * 255;
        d.data[i] = 94 + v * .4; d.data[i + 1] = 46 + v * .3; d.data[i + 2] = 32 + v * .25; d.data[i + 3] = Math.random() * 70;
      }
      x.putImageData(d, 0, 0);
    })();
    var patron = gx.createPattern(ruido, 'repeat');

    var TERRA = [173, 86, 59], TEJA = [138, 64, 41], CACAO = [94, 46, 32],
        ARENA = [235, 211, 161], CREMA = [252, 252, 214], LILA = [201, 180, 227],
        MELOCOTON = [246, 224, 204];
    var TONOS = {
      tierra: { base: MELOCOTON, m: [TERRA, ARENA, TEJA] },
      lila:   { base: MELOCOTON, m: [LILA, TERRA, ARENA] },
      arena:  { base: CREMA,     m: [ARENA, TERRA, ARENA] },
      teja:   { base: ARENA,     m: [TEJA, CACAO, TERRA] }
    };

    var ESF = [
      { x: .52, y: .48, kD: .5, kM: .62 },
      { x: .1, y: .86, kD: .36, kM: .5 },
      { x: .92, y: .14, kD: .32, kM: .46 }
    ];

    var secciones = [].slice.call(pagina.querySelectorAll('[data-vf-tono]'));
    var W, H, movil;
    function medir() {
      W = root.clientWidth; H = root.clientHeight;
      cv.width = Math.round(W * .5); cv.height = Math.round(H * .5);
      gv.width = Math.round(W); gv.height = Math.round(H);
      mv.width = gv.width; mv.height = gv.height;
      movil = W < 700;
      root.style.setProperty('--vf-blur', (movil ? 16 : 28) + 'px');
    }

    var mezcla = function (a, b, f) { return [0, 1, 2].map(function (i) { return Math.round(a[i] + (b[i] - a[i]) * f); }); };
    var suave = function (f) { f = Math.max(0, Math.min(1, f)); return f * f * (3 - 2 * f); };

    function tonoAhora() {
      var centro = innerHeight / 2, cs = secciones.map(function (s) {
        var r = s.getBoundingClientRect(); return r.top + r.height / 2;
      });
      var i = 0;
      while (i < cs.length - 1 && cs[i + 1] <= centro) i++;
      var a = TONOS[secciones[i].getAttribute('data-vf-tono')] || TONOS.tierra;
      if (i === cs.length - 1 || cs[i] > centro) return a;
      var b = TONOS[secciones[i + 1].getAttribute('data-vf-tono')] || a;
      var f = suave((centro - cs[i]) / (cs[i + 1] - cs[i]));
      return { base: mezcla(a.base, b.base, f), m: a.m.map(function (c, j) { return mezcla(c, b.m[j], f); }) };
    }

    function pintar(t) {
      var s = cv.width / W;
      cx.setTransform(s, 0, 0, s, 0, 0);
      cx.clearRect(0, 0, W, H);
      mx.clearRect(0, 0, W, H);
      var lado = Math.min(W, H), tono = tonoAhora(), sc = scrollY;

      ESF.forEach(function (e, k) {
        var tt = t + k * 3.1;

        var x = W * e.x + Math.sin(tt * .3) * lado * .12;
        var y = H * e.y + Math.sin(tt * .22 + 1.3) * lado * .08 + Math.sin(sc * .0011 + k * 2) * H * .06;
        var r = lado * (movil ? e.kM : e.kD) * (1 + Math.sin(tt * .6) * .06);
        var manchas = tono.m.slice(k).concat(tono.m.slice(0, k));

        var g = cx.createRadialGradient(x, y, 0, x, y, r);
        g.addColorStop(0, 'rgba(' + tono.base + ',1)');
        g.addColorStop(.96, 'rgba(' + tono.base + ',1)');
        g.addColorStop(1, 'rgba(' + tono.base + ',0)');
        cx.fillStyle = g; cx.beginPath(); cx.arc(x, y, r, 0, 6.283); cx.fill();

        cx.save(); cx.beginPath(); cx.arc(x, y, r * .98, 0, 6.283); cx.clip();
        manchas.forEach(function (c, j) {
          var a = tt * (.4 + j * .12) * (j % 2 ? -1 : 1) + j * 2.1;
          var px = x + Math.cos(a) * r * .5, py = y + Math.sin(a * 1.3) * r * .45;
          var pr = r * (j === 1 ? .8 : .7);
          var gm = cx.createRadialGradient(px, py, 0, px, py, pr);
          gm.addColorStop(0, 'rgba(' + c + ',.9)');
          gm.addColorStop(1, 'rgba(' + c + ',0)');
          cx.fillStyle = gm; cx.fillRect(x - r, y - r, 2 * r, 2 * r);
        });
        cx.restore();

        var gm2 = mx.createRadialGradient(x, y, r * .4, x, y, r * 1.08);
        gm2.addColorStop(0, 'rgba(0,0,0,1)'); gm2.addColorStop(1, 'rgba(0,0,0,0)');
        mx.fillStyle = gm2; mx.fillRect(x - r * 1.1, y - r * 1.1, r * 2.2, r * 2.2);
      });

      gx.globalCompositeOperation = 'source-over';
      gx.clearRect(0, 0, W, H); gx.fillStyle = patron; gx.fillRect(0, 0, W, H);
      gx.globalCompositeOperation = 'destination-in'; gx.drawImage(mv, 0, 0);
      gx.globalCompositeOperation = 'source-over';
    }

    var t0 = null, raf = 0, visible = false;
    function cuadro(ahora) {
      raf = 0;
      if (!visible) return;
      if (t0 === null) t0 = ahora;
      pintar((ahora - t0) / 1000 + 4);
      if (!quieto) raf = requestAnimationFrame(cuadro);
    }
    function pedir() { if (!raf) raf = requestAnimationFrame(cuadro); }

    medir();
    addEventListener('resize', function () { medir(); pedir(); });
    if (quieto) addEventListener('scroll', pedir, { passive: true });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        visible = es[0].isIntersecting;
        if (visible) pedir();
      }).observe(pagina);
    } else { visible = true; pedir(); }
  }

  function iniciarTarjetasMetal() {
    var m = document.querySelector('[data-vf-metal]');
    if (!m || !window.matchMedia('(hover: hover)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    m.addEventListener('pointermove', function (e) {
      var r = m.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
      m.style.setProperty('--ry', (x * 14).toFixed(2) + 'deg');
      m.style.setProperty('--rx', (-y * 12).toFixed(2) + 'deg');
    });
    m.addEventListener('pointerleave', function () {
      m.style.setProperty('--ry', '0deg'); m.style.setProperty('--rx', '0deg');
    });
  }

  function abrirWidgetFamily() {
    document.addEventListener('click', function (ev) {
      var b = ev.target.closest && ev.target.closest('[data-vf-widget]');
      if (!b) return;
      ev.preventDefault();
      var lanzador = document.getElementById('appstle-loyalty-button');
      if (lanzador) lanzador.click();
      else window.location.href = '/account';
    });
  }

  function iniciarCuestionario() {
    var zona = document.querySelector('[data-cq]');
    if (!zona) return;

    var VARIANTES = { 1: '57567941001596', 2: '57567941034364', 3: '57567941067132' };

    var PLAN_MES  = { 2: '832416448892', 3: '832416481660' };
    var PRECIO    = { una: { 1: '39,90 €' }, sus: { 2: '59,90 €', 3: '79,90 €' } };
    var SUELTOS   = { 2: '79,80 €', 3: '119,70 €' };
    var PCT       = { 2: '25', 3: '33' };

    var LOGO_FAMILY = '<svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="-2.8 27.5 629.5 77.4"><path fill="currentColor" d="M37.2 45.2 23.2 86.2H21.8L7.9 45.2H-0.8L18.2 100H26.8L45.8 45.2ZM96.2 71.7C96.2 63 93.6 42.8 72.7 42.8C49.7 42.8 45.1 63.6 45.1 72.6C45.1 91.8 54.9 102.4 72.7 102.4C78.9 102.4 87.3 100.1 92.5 93.8L86 88.5C82.9 92.4 77.1 94.1 72.7 94.1C60.6 94.1 54.4 88.3 53.5 75.9H96.2ZM53.7 67.6C54.9 59.2 59.4 51.1 72.7 51.1C83.7 51.1 86.9 60.1 87.7 67.6ZM133.3 45.2 119.3 86.2H117.9L104 45.2H95.3L114.3 100H122.9L141.9 45.2ZM177.4 45.2 163.4 86.2H162L148.1 45.2H139.4L158.4 100H167L186 45.2ZM195.4 38.5V29.5H187.1V38.5ZM195.4 100V45.2H187.1V100ZM246.8 84.7C246.8 82.8 247.2 72.6 247.2 72.6C247.2 57.7 241.3 42.8 219.6 42.8C212.2 42.8 205.9 44.7 201.1 48.5L206.2 55C209.5 52.4 214 51.1 219.6 51.1C233.1 51.1 237.6 59.5 238.6 68.1H237.5C237.5 68.1 231.9 59 221.6 59C204.6 59 198.1 70.1 198.1 80.1C198.1 91.2 206.4 102.9 221.7 102.9C232.5 102.9 237 95.4 239.3 93.1H240.5C243.3 98.4 248.4 101.5 251.5 102.3L253.4 94.2C252.8 94 246.8 92.3 246.8 84.7ZM221.7 94.6C211.7 94.6 206.4 87.3 206.4 80.1C206.4 69.9 216.6 67.3 221.6 67.3C231.8 67.3 238.2 74.2 238.2 80.9C238.2 86.1 234.6 94.6 221.7 94.6Z"/><rect x="301.7" y="47.8" width="3" height="49.6" fill="currentColor" fill-opacity="0.5"/><path fill="currentColor" fill-opacity="0.8" d="M385 52.7H357.4V92.5H364.5V75.1H382.5V69.5H364.5V58.6H385ZM422.2 52.6H414.8L399.4 92.5H406.6L410.5 82H426.3L430.1 92.5H437.6ZM424.5 76.7H412.3L418.6 59.9ZM496.3 52.7H486.5L475.8 83.9L464.6 52.7H454.8V92.5H461.4V61.8L472.8 92.5H478.5L489.6 61.8V92.5H496.3ZM525.2 52.7H518.1V92.5H525.2ZM574.3 86.5H554.1V52.7H547V92.5H574.3ZM625.1 52.7H617.3L606.8 70.3L596.2 52.7H588.2L603.2 76.7V92.5H610.1V76.7Z"/></svg>';
    var FLECHA = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    var R = {};
    var actual = 1;

    function t(k, v) {
      var s = (window.VEVVIA_I18N && window.VEVVIA_I18N.t('pagCuestionario.' + k)) || '';
      if (v) Object.keys(v).forEach(function (x) { s = s.split('{' + x + '}').join(v[x]); });
      return s;
    }
    function $(s) { return zona.querySelector(s); }

    function marca(x) {
      var d = document.createElement('div'); d.textContent = x;
      return d.innerHTML.replace(/vevvia/g, '<span class="marca">vevvia</span>');
    }

    var PAL = {
      1: ['#5E2E20', '#AD563B', '#EBD3A1'], 2: ['#7A3A26', '#D08A5E', '#F0DDB5'],
      3: ['#4A2318', '#9C6C86', '#D9A77F'], 4: ['#5E2E20', '#EBD3A1', '#C46A4A'],
      5: ['#3F1D14', '#AD563B', '#EBD3A1']
    };
    function hex(x) { return [1, 3, 5].map(function (i) { return parseInt(x.slice(i, i + 2), 16); }); }
    var cv = $('.cq__lienzo');
    var cx = cv && cv.getContext && cv.getContext('2d');
    var col = PAL[1].map(hex);
    var dest = col.map(function (c) { return c.slice(); });
    var quieto = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    var t0 = performance.now();

    function talla() {
      if (!cv) return;
      var r = cv.getBoundingClientRect();
      cv.width = Math.max(2, r.width / 6 | 0);
      cv.height = Math.max(2, r.height / 6 | 0);
    }
    function rgba(c, a) { return 'rgba(' + c.map(Math.round).join(',') + ',' + a + ')'; }
    function pinta(ahora) {
      var s = quieto ? 0 : (ahora - t0) / 1000, W = cv.width, H = cv.height;
      col = col.map(function (c, i) { return c.map(function (v, j) { return v + (dest[i][j] - v) * 0.035; }); });
      cx.fillStyle = rgba(col[0], 1);
      cx.fillRect(0, 0, W, H);
      [[.28 + .18 * Math.sin(s * .13), .38 + .14 * Math.sin(s * .26), .5, 1],
       [.74 + .14 * Math.cos(s * .11), .7 + .12 * Math.sin(s * .17), .45, 2],
       [.55 + .2 * Math.sin(s * .09 + 1), .12 + .1 * Math.cos(s * .21), .35, 2]].forEach(function (b) {
        var g = cx.createRadialGradient(b[0] * W, b[1] * H, 0, b[0] * W, b[1] * H, b[2] * Math.max(W, H));
        g.addColorStop(0, rgba(col[b[3]], .95));
        g.addColorStop(1, rgba(col[b[3]], 0));
        cx.fillStyle = g;
        cx.fillRect(0, 0, W, H);
      });
      requestAnimationFrame(pinta);
    }
    if (cx) { talla(); window.addEventListener('resize', talla); requestAnimationFrame(pinta); }

    function receta() {
      if (R.busca === 'probar') return { pack: 1, sus: false };
      if (R.busca === 'nota' || R.edad === 'mayor' || R.dia === 'activo') return { pack: 3, sus: true };
      return { pack: 2, sus: true };
    }

    function pintarResultado() {
      var r = receta();
      var cap = function (x) { return x.charAt(0).toUpperCase() + x.slice(1); };
      $('[data-cq-rt]').textContent = t('rt' + r.pack);
      $('[data-cq-rs]').textContent = t(r.sus ? 'rsSus' : 'rsUna');

      var sello = $('[data-cq-sello]');
      sello.classList.toggle('cq__sello--fam', r.sus);
      sello.innerHTML = r.sus
        ? '<span class="cq__sello-logo">' + LOGO_FAMILY + '</span><i class="cq__sello-pct">' + t('selloSus', { pct: PCT[r.pack] }) + '</i>'
        : marca(t('selloUna'));
      $('[data-cq-pack]').textContent = r.pack === 1 ? t('bote1') : t('boteN', { n: r.pack });
      $('[data-cq-precio]').textContent = r.sus ? t('cadaEnvio', { precio: PRECIO.sus[r.pack] }) : PRECIO.una[1];
      $('[data-cq-letra]').textContent = r.sus ? t('sueltos', { precio: SUELTOS[r.pack] }) : t('devolucion');

      var ol = $('[data-cq-porque]');
      ol.innerHTML = '';
      [t('e' + cap(R.edad || 'adulto')), t('d' + cap(R.dia || 'normal')), t(r.sus ? 'uSus' : 'uUna')].forEach(function (x) {
        var li = document.createElement('li');

        li.innerHTML = '<span>' + marca(x) + '</span>';
        ol.appendChild(li);
      });

      var b = $('[data-cq-comprar]');
      b.disabled = false;
      b.innerHTML = '';
      var sp = document.createElement('span');
      sp.textContent = r.sus ? t('btnSus', { precio: PRECIO.sus[r.pack] }) : t('btnUna', { precio: PRECIO.una[1] });
      b.appendChild(sp);
      b.insertAdjacentHTML('beforeend', FLECHA);

      var ver = $('[data-cq-opciones]');
      if (ver) {
        var base = ver.getAttribute('data-base') || ver.getAttribute('href').split(/[?#]/)[0];
        ver.setAttribute('data-base', base);
        ver.setAttribute('href', base + '?variant=' + VARIANTES[r.pack] + (r.sus ? '&modo=family' : '') + '#comprar');
      }

      zona.querySelectorAll('[data-cq-bote]').forEach(function (img) {
        img.classList.toggle('on', Number(img.getAttribute('data-cq-bote')) === r.pack);
      });
    }

    var pasos = zona.querySelectorAll('[data-cq-paso]');
    var rayas = zona.querySelectorAll('.cq__prog i');
    var atras = $('[data-cq-atras]');

    function ir(n) {
      actual = n;
      pasos.forEach(function (p) {
        var este = Number(p.getAttribute('data-cq-paso')) === n;
        p.hidden = !este;
        p.classList.toggle('cq__paso--on', este);
      });
      dest = PAL[n].map(hex);
      $('[data-cq-grande]').textContent = n <= 3 ? '0' + n : (n === 4 ? '@' : '');
      $('[data-cq-num]').textContent = n <= 3 ? '0' + n + ' / 03' : (n === 4 ? '03 / 03' : t('listo'));
      rayas.forEach(function (x, i) { x.classList.toggle('on', i < Math.min(n, 3)); });
      atras.hidden = n === 1 || n === 5;
      if (n === 5) pintarResultado();
      zona.classList.toggle('cq--fin', n === 5);

      var nav = document.getElementById('nav');
      var alto = nav ? nav.getBoundingClientRect().height : 56;
      var arriba = zona.getBoundingClientRect().top;
      if (arriba < alto - 1) window.scrollTo({ top: Math.max(0, window.scrollY + arriba - alto), behavior: 'smooth' });
      var h = zona.querySelector('[data-cq-paso="' + n + '"] h1');
      if (h) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); }
    }

    zona.querySelectorAll('[data-cq-q]').forEach(function (o) {
      o.addEventListener('click', function () {
        R[o.getAttribute('data-cq-q')] = o.getAttribute('data-cq-v');
        o.parentNode.querySelectorAll('[data-cq-q]').forEach(function (x) { x.classList.toggle('sel', x === o); });
        setTimeout(function () { ir(actual === 3 ? 5 : actual + 1); }, 380);
      });
    });
    atras.addEventListener('click', function () { ir(Math.max(1, actual - 1)); });
    $('[data-cq-otra]').addEventListener('click', function () {
      R = {};
      zona.querySelectorAll('.cq__op.sel').forEach(function (x) { x.classList.remove('sel'); });
      ir(1);
    });

    var cerrar = $('[data-cq-cerrar]');
    if (cerrar) cerrar.addEventListener('click', function (e) {
      var deAqui = document.referrer && document.referrer.indexOf(location.origin) === 0;
      if (deAqui && history.length > 1) { e.preventDefault(); history.back(); }
    });

    $('[data-cq-comprar]').addEventListener('click', function () {
      var r = receta();
      var b = this;
      var cuerpo = { id: Number(VARIANTES[r.pack]), quantity: 1 };
      if (r.sus) cuerpo.selling_plan = Number(PLAN_MES[r.pack]);
      b.disabled = true;
      b.querySelector('span').textContent = t('anadiendo');
      fetch(location.origin + '/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(cuerpo)
      })
        .then(function (res) { if (!res.ok) throw new Error('no entro'); return res.json(); })
        .then(function () {
          pintarResultado();
          var abre = document.querySelector('[data-carrito-abrir]');
          if (abre) abre.click();
        })
        .catch(function () {
          var ver = $('[data-cq-opciones]');
          location.href = ver ? ver.href : '/';
        });
    });

    ir(1);

    if (document.activeElement && document.activeElement.id === 'cq-t1') document.activeElement.blur();
  }

  function chatEnNav() {

    function buscar(raiz) {
      var e = raiz.querySelector('[part~="activator"]');
      if (e) return e;
      var t = raiz.querySelectorAll('*');
      for (var i = 0; i < t.length; i++) if (t[i].shadowRoot) { e = buscar(t[i].shadowRoot); if (e) return e; }
      return null;
    }
    document.querySelectorAll('[data-chat-abrir]').forEach(function (b) {
      b.addEventListener('click', function (ev) {
        var h = document.querySelector('shopify-chat');
        var a = h && h.shadowRoot && buscar(h.shadowRoot);
        if (!a) { location.href = '/#faq'; return; }

        ev.stopPropagation();
        setTimeout(function () { a.click(); }, 0);
      });
    });
  }

  function navCristal() {
    var hn = document.querySelector('.hn');
    if (!hn) return;
    var pend = false;
    function mirar() {
      pend = false;
      hn.classList.toggle('hn--flota', (window.scrollY || document.documentElement.scrollTop) > 40);
    }
    window.addEventListener('scroll', function () {
      if (!pend) { pend = true; requestAnimationFrame(mirar); }
    }, { passive: true, capture: true });
    mirar();
  }

  function iniciarNavHuel() {
    var nav = document.querySelector('.hn');
    if (!nav) return;
    var velo = document.querySelector('[data-hn-velo]');
    var botones = nav.querySelectorAll('[data-hn]');
    var abierto = null;
    var reloj;

    function abrirPanel(k) {
      abierto = k;
      botones.forEach(function (b) {
        var este = b.getAttribute('data-hn') === k;
        b.setAttribute('aria-expanded', este ? 'true' : 'false');
        var p = document.getElementById('hn-' + b.getAttribute('data-hn'));
        if (p) p.hidden = !este;
      });
      if (velo) {

        if (k) velo.style.setProperty('--hn-velo-top', Math.max(0, nav.getBoundingClientRect().bottom) + 'px');
        velo.hidden = !k;
      }
    }

    var conRaton = window.matchMedia && matchMedia('(hover: hover)').matches;
    botones.forEach(function (b) {
      var k = b.getAttribute('data-hn');
      b.addEventListener('click', function () { abrirPanel(abierto === k ? null : k); });
      if (conRaton) b.addEventListener('mouseenter', function () {
        clearTimeout(reloj);
        reloj = setTimeout(function () { abrirPanel(k); }, abierto ? 0 : 120);
      });
    });
    nav.querySelectorAll('.hn__menu > li > a').forEach(function (a) {
      if (conRaton) a.addEventListener('mouseenter', function () { clearTimeout(reloj); abrirPanel(null); });
    });
    if (conRaton) {
      nav.addEventListener('mouseleave', function () { clearTimeout(reloj); reloj = setTimeout(function () { abrirPanel(null); }, 200); });
      nav.addEventListener('mouseenter', function () { if (abierto) clearTimeout(reloj); });
    }
    if (velo) velo.addEventListener('click', function () { abrirPanel(null); });

    nav.querySelectorAll('[data-hn-tab]').forEach(function (t) {
      function elegir() {
        nav.querySelectorAll('[data-hn-tab]').forEach(function (x) { x.classList.toggle('on', x === t); });
        nav.querySelectorAll('[data-hn-panel]').forEach(function (p) {
          p.hidden = p.getAttribute('data-hn-panel') !== t.getAttribute('data-hn-tab');
        });
      }
      t.addEventListener('click', elegir);
      t.addEventListener('mouseenter', elegir);
    });

    var ham = nav.querySelector('.hn__ham');
    var cajon = document.getElementById('hn-cajon');

    function verSub(k) {
      if (!cajon) return;
      cajon.classList.toggle('sub', !!k);
      cajon.querySelectorAll('[data-hn-vista]').forEach(function (v) {
        v.classList.toggle('on', v.getAttribute('data-hn-vista') === k);
      });
    }
    function cajonAbre(si) {
      if (!cajon) return;
      cajon.classList.toggle('abierto', si);
      document.body.classList.toggle('sin-scroll', si);
      if (ham) {
        ham.setAttribute('aria-expanded', si ? 'true' : 'false');
        if (!si) ham.focus({ preventScroll: true });
      }
      if (si) {
        var c = cajon.querySelector('[data-hn-cerrar]');
        if (c) setTimeout(function () { c.focus({ preventScroll: true }); }, 50);
      } else {
        setTimeout(function () { verSub(null); }, 350);
      }
    }
    if (ham && cajon) {
      ham.addEventListener('click', function () { cajonAbre(true); });
      cajon.querySelectorAll('[data-hn-cerrar]').forEach(function (b) { b.addEventListener('click', function () { cajonAbre(false); }); });
      cajon.querySelectorAll('[data-hn-sub]').forEach(function (b) {
        b.addEventListener('click', function () { verSub(b.getAttribute('data-hn-sub')); });
      });
      cajon.querySelectorAll('[data-hn-atras]').forEach(function (b) { b.addEventListener('click', function () { verSub(null); }); });
      cajon.querySelectorAll('[data-hn-seg]').forEach(function (s) {
        s.addEventListener('click', function () {
          cajon.querySelectorAll('[data-hn-seg]').forEach(function (x) { x.classList.toggle('on', x === s); });
          cajon.querySelectorAll('[data-hn-segp]').forEach(function (p) {
            p.hidden = p.getAttribute('data-hn-segp') !== s.getAttribute('data-hn-seg');
          });
        });
      });

      cajon.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { cajonAbre(false); }); });
    }
    nav.querySelectorAll('.hn-mega a').forEach(function (a) { a.addEventListener('click', function () { abrirPanel(null); }); });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (abierto) abrirPanel(null);
      if (cajon && cajon.classList.contains('abierto')) cajonAbre(false);
    });
  }

  function iniciarCinta() {
    var cinta = document.querySelector('[data-anc]');
    if (!cinta) return;
    var ventana = cinta.querySelector('[data-anc-ventana]');
    var lista = cinta.querySelector('.anc__lista');
    var boton = cinta.querySelector('[data-anc-pausa]');
    if (!ventana || !lista) return;

    var quieto = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    var pausado = quieto;
    var encima = false;
    var VEL = 32;
    var pos = 0, antes = 0;
    if (boton) boton.setAttribute('aria-pressed', pausado ? 'true' : 'false');

    function paso(t) {
      var dt = antes ? Math.min(64, t - antes) : 0;
      antes = t;
      if (!pausado && !encima && !document.hidden) {
        var mitad = lista.offsetWidth;
        pos += VEL * dt / 1000;
        if (mitad && pos >= mitad) pos -= mitad;
        ventana.scrollLeft = pos;
      }
      requestAnimationFrame(paso);
    }
    requestAnimationFrame(paso);

    ventana.addEventListener('mouseenter', function () { encima = true; });
    ventana.addEventListener('mouseleave', function () { encima = false; });
    if (boton) boton.addEventListener('click', function () {
      pausado = !pausado;
      boton.setAttribute('aria-pressed', pausado ? 'true' : 'false');
    });
  }

  function iniciarVideosFicha() {
    var pista = document.querySelector('[data-videos-pista]');
    if (!pista) return;
    var seccion = pista.closest('.videos');
    if (seccion) seccion.classList.add('videos--ficha');
    var tarjetas = [].slice.call(pista.querySelectorAll('.videos__tarjeta'));
    var minis = tarjetas.map(function (t) { return t.querySelector('video'); });
    if (!minis.length) return;

    function t(k) { return (window.VEVVIA_I18N && window.VEVVIA_I18N.t('videos.' + k)) || ''; }
    function fuente(v) { var s = v.querySelector('source'); return v.currentSrc || (s && s.src) || v.src; }

    minis.forEach(function (v) {
      v.muted = true; v.loop = true; v.playsInline = true;
      v.setAttribute('muted', ''); v.setAttribute('aria-hidden', 'true');
    });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) { v.preload = 'auto'; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          else v.pause();
        });
      }, { threshold: 0.25 });
      minis.forEach(function (v) { io.observe(v); });
    }

    var caja = document.createElement('div');
    caja.className = 'vmodal';
    caja.hidden = true;
    caja.setAttribute('role', 'dialog');
    caja.setAttribute('aria-label', t('titulo'));
    caja.innerHTML =
      '<div class="vmodal__caja">' +
        '<video class="vmodal__video" playsinline controls></video>' +
        '<button type="button" class="vmodal__cerrar" data-vm-cerrar><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button>' +
        '<button type="button" class="vmodal__nav vmodal__nav--ant" data-vm-ir="-1"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 15l6-6 6 6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
        '<button type="button" class="vmodal__nav vmodal__nav--sig" data-vm-ir="1"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 9l6 6 6-6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
      '</div>';
    document.body.appendChild(caja);
    var grande = caja.querySelector('video');
    var cerrarB = caja.querySelector('[data-vm-cerrar]');
    var antB = caja.querySelector('[data-vm-ir="-1"]');
    var sigB = caja.querySelector('[data-vm-ir="1"]');
    cerrarB.setAttribute('aria-label', t('cerrar'));
    antB.setAttribute('aria-label', t('anterior'));
    sigB.setAttribute('aria-label', t('siguiente'));
    var actual = -1;

    function abrir(i) {
      actual = i;
      var m = minis[i];
      grande.poster = m.poster || '';
      grande.src = fuente(m);
      grande.muted = false;
      caja.hidden = false;
      requestAnimationFrame(function () { caja.classList.add('abierta'); });
      var p = grande.play(); if (p && p.catch) p.catch(function () {});
      antB.classList.toggle('apagado', i === 0);
      sigB.classList.toggle('apagado', i === minis.length - 1);
    }
    function cerrar() {
      grande.pause();
      caja.classList.remove('abierta');
      setTimeout(function () { if (!caja.classList.contains('abierta')) { caja.hidden = true; grande.removeAttribute('src'); grande.load(); } }, 300);
      actual = -1;
    }

    tarjetas.forEach(function (tj, i) {
      tj.setAttribute('role', 'button');
      tj.setAttribute('tabindex', '0');
      tj.setAttribute('aria-label', t('reproducir'));
      tj.addEventListener('click', function (e) { e.preventDefault(); abrir(i); });
      tj.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); abrir(i); } });
    });
    cerrarB.addEventListener('click', cerrar);
    antB.addEventListener('click', function () { if (actual > 0) abrir(actual - 1); });
    sigB.addEventListener('click', function () { if (actual < minis.length - 1) abrir(actual + 1); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !caja.hidden) cerrar(); });
  }

  function iniciarGuias() {
    var cuerpo = document.querySelector('[data-gv-cuerpo]');
    if (!cuerpo) return;

    var plantilla = document.querySelector('template[data-gv-tarjeta]');
    if (plantilla) {
      var sitio = cuerpo.querySelector('.g-producto') || cuerpo.querySelector('.g-faq');
      var tarjeta = plantilla.content.cloneNode(true);
      if (sitio && sitio.classList.contains('g-producto')) sitio.replaceWith(tarjeta);
      else if (sitio) sitio.parentNode.insertBefore(tarjeta, sitio);
    }

    var indice = document.querySelector('[data-gv-indice]');
    if (!indice) return;
    var titulos = [].slice.call(cuerpo.querySelectorAll('h2'));
    var breve = cuerpo.querySelector('.g-breve');
    var enlaces = [];
    function poner(destino, texto) {
      if (!destino.id) destino.id = 'g-' + texto.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
      var a = document.createElement('a');
      a.href = '#' + destino.id;
      a.textContent = texto;
      indice.appendChild(a);
      enlaces.push({ a: a, el: destino });
    }
    if (breve) poner(breve, 'En breve');
    titulos.forEach(function (h) { poner(h, h.textContent.trim()); });
    if (!('IntersectionObserver' in window) || !enlaces.length) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        enlaces.forEach(function (x) { x.a.classList.toggle('on', x.el === e.target); });
      });
    }, { rootMargin: '-20% 0px -70% 0px' });
    enlaces.forEach(function (x) { io.observe(x.el); });
  }

  function arrancar() {
    abrirWidgetFamily();
    iniciarAuraFamily();
    iniciarTarjetasMetal();
    pintarTablaFaq(document);
    elegirFormato();
    compraPacks();
    vestirSuscripcion();

    iniciarAnuncios();
    iniciarCinta();
    iniciarMarquesina();
    iniciarTiraCompra();
    iniciarMenu();
    iniciarNavHuel();
    navCristal();
    chatEnNav();
    iniciarLamas();
    iniciarCarrito();
    iniciarProgreso();
    iniciarResenas();
    iniciarVideosFicha();
    iniciarCalidad();
    iniciarCalculadora(document);
    iniciarMiniaturas();
    iniciarZoom();

    vestirBarraCompra();
    iniciarBarraSeed();
    iniciarVets();
    vestirBundle();
    vestirCajitas();
    iniciarSenales();
    estrellasAResenas();
    anillosCifras();
    var fp = document.querySelector('[data-polvo]'); if (fp && window.vevviaPolvo) window.vevviaPolvo(fp);
    botonesQueEligen();
    iniciarQuiz();
    iniciarCuestionario();
    iniciarGuias();
    iniciarNavSolido();
    iniciarMovimiento();
  }

  I18N.listo.then(arrancar, arrancar);
})();
